// src/components/register/components/TermsModal.jsx

import React from 'react';
import { Spin } from 'antd';

const TERMS_AND_CONDITIONS_TEXT = `Términos y condiciones del servicio
Fecha de modificación: Martes 15 de enero 2026, a las 1:19 P. M.
Términos y Condiciones del Servicio
Términos y Condiciones
Términos y condiciones generales, que regulan la prestación de servicios para la aceptación
de pago y el acceso al sistema Peiix, mismos que son un acuerdo legalmente ejecutable. Estos
Términos y Condiciones de Uso ("los Términos ") constituyen un contrato para la prestación de
servicios de aceptación de pagos (“Contrato”) y regulan la relación entre la persona natural o
jurídica que utiliza el Sistema (según se define más adelante) para efectos de vender sus
productos y/o servicios (“Usuario”) y/o, en caso de ser aplicable, sus Terceros Vinculados; y
SANTA FE SMARTECH SYSTEMS DE MEXICO, S.A.P.I de C.V., ("Peiix").
Peiix es una Sociedad Mercantil, debidamente constituida de conformidad con las leyes de los
Estados Unidos Mexicanos, que presta un servicio que permite a cualquier persona física o
moral que lo solicite, la aceptación de pagos de tarjetas presentes o no presentes de débito y
de crédito, o bien, de cualquier tarjeta de valor almacenado, asociado o no a una Cuenta, de la
que el Tarjetahabiente es titular y utiliza como medio de pago para la domiciliación de pagos, así
como pagos por evento, pagos periódicos o recurrentes y/o pagos por única ocasión, entre otros
(“Medios de pago y/o Tarjeta”), a través de teléfonos inteligentes o tabletas (los “Dispositivos
Móviles”), teléfono o internet en los Estados Unidos Mexicanos (el "Servicio"). A continuación,
se establecen los términos y condiciones de la prestación del Servicio, entendidos como parte
del acuerdo de voluntades vinculatorio para Las Partes (los "Términos").
El Servicio y su promoción se rigen por la legislación mexicana y por los sistemas reglamentarios
que el Adquirente de Peiix y las redes de tarjetas, incluidas American Express, Visa y MasterCard,
(las "Redes") deban aplicar en todo momento.
Al vincularse, registrarse y/o hacer usar la página web, aplicaciones móviles, APIs,
herramientas digitales y el software propiedad de Peiix (el “Software”) y/o contratar los
Servicios, el Usuario se obliga de conformidad con el alcance de los Términos. Por lo tanto,
los presentes Términos constituyen un contrato vinculante, así como el acuerdo total
entre el Usuario y Peiix (conjuntamente referidos como las “Partes” o individualmente como la
“Parte”).
El Usuario declara i) haber leído y estar conforme con los Términos, que ii) conoce en forma
detallada y específica los Servicios, condiciones y estándares de los Términos, y iii) acepta que
los derechos y obligaciones del Usuario en relación con el Servicio se rijan por estos Términos
y, por tanto, se obliga a cumplirlos, así como se obliga a cumplir con todas las leyes que le
pudieran ser aplicables, reglas y reglamentos relativos a la conducción de su negocio. El Usuario
reconoce que su firma electrónica en aceptación de los Términos y documentos de afiliación a los
Servicios tiene el mismo efecto vinculante que el que tendría su firma sobre un documento físico
de haberse firmado de forma autógrafa.
Términos y condiciones del servicio Peiix
DEFINICIONES
Para los fines de los presentes Términos y su correcta interpretación, las Partes convienen en
que los términos que se escriban con mayúscula en la letra inicial tendrán el significado que
se les atribuye en las definiciones siguientes, y las establecidas anteriormente en el párrafo
primero en el entendido de que dichas definiciones aplicarán para el género masculino o
femenino, e independientemente de que los mismos se usen en singular o plural:
“Acuerdo Comercial o Contrato”: Es el contrato estándar de Peiix firmado por el Usuario, su
apoderado o representante legal (en caso de tratarse de una persona moral) o, según
corresponda, la relación contractual originada entre el Usuario y Peiix con ocasión del uso que
realiza el primero de los Servicios. En ambos casos, será entendido por Las Partes que el
Contrato se sujeta a los Términos.
“Adquirente”: Se entenderá la entidad que adquiere o procesa pagos con Tarjetas y ha sido
autorizada para ello por las Redes y/o las Autoridades. Para efecto de los Términos, el Adquirente
será un Banco o un tercero autorizado por la Ley Aplicable, elegido a discreción de Peiix.
"Ajustes": Los que resulte necesario realizar en el proceso de liquidación al usuario, con el objetivo
de incluir en la operación de liquidación ajustes o modificaciones realizados por los Participantes
o las Autoridades respecto de las Tasas de Descuento, tarifas o tasas impositivas.
“Aplicación”: Aplicación tecnológica para Dispositivos Móviles de Peiix.
“Autoridades”: Se entenderá por tales a la Comisión Nacional Bancaria y de Valores y al Banco
de México, conjuntamente; también a cualquier entidad pública o privada que emita normativa,
regulación, parámetros y/o instrucciones aplicables a los Servicios.
“Comisión”: A los cargos que Peiix cobra a los Usuarios por el uso del Servicio para la aceptación
de Medios de Pago.
“Contracargos”: Se entenderá como el mecanismo creado para solucionar aquellos cargos que
se realizan a una Tarjeta que no son reconocidos por su titular. Entre las razones que ocasionan
los Contracargos están: (i) la duplicidad de la Tarjeta o del pago, (ii) falta de reconocimiento de la
Transacción, (iii) falta de entrega de bienes o servicios, (iv) comportamiento engañoso y
deshonesto y/o (v) Transacciones Fraudulentas, entre otros. Salvo pacto expreso en contrario,
como regla general, el Usuario es responsable por los Contracargos.
“Contrato de Adquirente”: Acto jurídico que incluye al Adquirente de Peiix como parte de la
relación, con el fin de seguir utilizando el Servicio.
“Cuenta”: Significará el contrato de apertura de crédito en cuenta corriente o el contrato de
depósito bancario de dinero a la vista, o cualesquiera aplicable, por medio del cual el
Tarjetahabiente tiene abierta con una Entidad Financiera (conforme dicho término se define en la
LTOSF) una cuenta a la que se le cargará, en los términos aquí establecidos, el monto total del
importe de las Ventas u Operaciones de Pago con Tarjetas realizadas por el Usuario.
Términos y condiciones del servicio Peiix
“Cuenta de Usuario o Cuenta Peiix”: Se entenderá como el conjunto de funcionalidades
relacionadas con el funcionamiento y la utilización de la Cuenta del Usuario dentro del Sistema,
donde aquel podrá acceder ingresando las credenciales de usuario y contraseña
correspondientes a la misma, a efectos de visualizar los diferentes módulos de información y los
saldos acreditados al Usuario como resultado de las Transacciones procesadas en el marco de
los Términos y el Acuerdo Comercial o Contrato, según aplique.
“Datos Relativos”: Son los datos proporcionados por los Tarjetahabientes al Usuario entre los
cuales se incluyen y no se limita a nombre completo, número de tarjeta de crédito, número de
seguridad de tarjeta de crédito y empresa de transacción de pagos.
“Derechos PI”: Significan todos y cada uno de los derechos relacionados directa o indirectamente
con el Servicio, la Aplicación, el Lector Peiix y la Página Web, nombres de dominio en Internet,
todo el contenido, la tecnología relacionada con los servicios, todas las marcas y logotipos, lo que
incluye pero no se limita a derechos de autor, derechos morales, derechos sobre bases de
datos, marcas comerciales registradas, derechos sobre nombres, modelos de utilidad, derechos
sobre diseños y patentes, y otros derechos exclusivos y no exclusivos a nivel mundial existentes
en la actualidad o que existan en el futuro, o que bien sean transferidos u otorgados en el futuro.
“Desconocimiento de Cargo”: Es una reclamación del Tarjetahabiente contra el Usuario
respecto de una Transacción no reconocida por este último, que se puede transformar en un
Contracargo.
“Devolución”: Es una cancelación de la Transacción por el pago de Medio de Pago por mutuo
acuerdo de las partes involucradas en un proceso de pago.
“Emisor”: Significa cualquier entidad Participante en Redes (conforme dicho término se define en
las Disposiciones de Carácter General aplicables a las Redes de Medios de Disposición
(“Disposiciones de Redes”) y la Ley para la Transparencia y Ordenamiento de los Servicios
Financieros (“LTOSF”); que expide Tarjetas y recibe las solicitudes de autorización de pago que
le dirige el Adquirente y genera las respectivas autorizaciones de pago, rechazos de pagos,
devoluciones y ajustes, con el objeto de ser enviados al Usuario a través del Sistema.
“Lector Peiix o Terminal de Punto de Venta (TPV)”: a los medios de acceso a la Red de Pagos
con Tarjeta, tales como dispositivos electrónicos, terminales, teléfonos móviles y programas de
cómputo, operados por Receptores de Pagos para instruir el pago de bienes o servicios con cargo
a una Tarjeta.
“Marca(s)”: Significa los signos distintivos registrados o en proceso de registro como
propiedad de Peiix y/o de sus empresas filiales, subsidiarias o controladoras, respecto
de los cuales Peiix está legalmente facultado para su uso y que distinguen el Sistema en los
Términos, específicamente la marca Peiix®, y cualquier otra que en el futuro distinga a los
productos que pudieran ser objeto de prestación de servicios en términos del presente
documento.
“México”: Se refiere a los Estados Unidos Mexicanos.
“Pagaré”: Se refiere al documento mediante el cual el Tarjetahabiente se obliga a pagar a la orden
del Emisor el importe consignado en el mismo, bajo los términos y condiciones establecidos
Términos y condiciones del servicio Peiix
en la Cuenta. El Pagaré podrá ser electrónico o impreso y contener la firma del
Tarjetahabiente electrónica o autógrafa, según corresponda a la naturaleza del documento.
“Página Web”: Significa la página web www.peiix.com
“Participante(s)”: Se entenderán Adquirentes, Emisores, Redes, procesadores y agregadores, u
otros terceros que presten servicios dentro de la cadena de pagos.
“Pasivos del Usuario”: aquellas sumas cuyo pago se encuentra a cargo del Usuario, dado que
corresponden, entre otros, a Comisiones, Contracargos, reversiones, recargos, cobros
realizados por las Redes, reembolsos, multas y/o penalidades, liquidadas, causadas u
originadas en actos u omisiones del Usuario asociados al cumplimiento de la Ley, los
reglamentos de las Autoridades o de las Redes, los Términos y/o el uso y/o disfrute de los
Servicios.
“Programa de Pagos Diferidos sin Intereses / Meses Sin Intereses”: el que permite a los
Tarjetahabientes adquirir los productos o servicios promocionados por el Usuario, mediante
pagos diferidos sin intereses o parcializados, ya que el cargo por las compras que realice bajo el
Programa de Pagos Diferidos sin Intereses, aparecerá de manera parcial en cada uno de los
estados de cuenta que reciba el Tarjetahabiente siguientes a la adquisición de los productos
o servicios de que se trate, es decir, la cantidad que resulte de dividir el 100% del importe de
la compra entre el número de meses establecidos en el Programa de Pagos Diferidos sin
Intereses, según las condiciones previstas en el Contrato.
El Tarjetahabiente, al momento de realizar su compra, podrá decidir si el cargo del importe por la
adquisición de los productos o servicios se difiere en mensualidades de conformidad con el
Programa de Pagos Diferidos.
Si el Tarjetahabiente decide que se difieran en mensualidades, el Usuario deberá de procesar
la compra a través del Lector Peiix con la aplicación de Pagos Diferidos sin Intereses
correspondiente de acuerdo al plazo de promoción pactado en el Contrato.
Las compras que realicen los Tarjetahabientes bajo el Programa de Pagos Diferidos sin Intereses
no generarán intereses, siempre y cuando el Tarjetahabiente cubra puntualmente y en los
términos del contrato de apertura de cuenta corriente correspondiente, el importe total de cada
parcialidad en que se divida dicha compra o consumo, según aparezca en su estado de cuenta.
“Red de Pagos con Tarjetas”: a la Red de Medios de Disposición relacionada con el uso de
Tarjetas como medio de pago.
“Representaciones”: Es el abono que Peiix realizará al Usuario en caso de que las gestiones
realizadas para resolver un Contracargo arrojen como resultado que el Desconocimiento del
Cargo no podía ser atribuible al Usuario y, por tanto, debe abonársele el valor de la Venta
respectiva.
“Sistema”: Significará el software diseñado por y bajo la titularidad y propiedad de Peiix con el
fin de que el Usuario lo utilice ÚNICA Y EXCLUSIVAMENTE para la ejecución de transacciones
electrónicas con Medios de Pago autorizados por Peiix, en el entendido que el Sistema es
propiedad exclusiva de Peiix, así como que aquellos datos electrónicos relevantes generados
Términos y condiciones del servicio Peiix
por la Transacción quedarán a resguardo de Peiix.
“Tarjetas”: a las Tarjetas de Crédito y Tarjetas de Débito.
“Tarjetas de Crédito”: al medio de disposición emitido al amparo de un contrato de apertura
de crédito en cuenta corriente, que el Emisor otorga a nombre del propio acreditado para que
este, mediante la utilización de dicho medio, pueda disponer de la línea de crédito otorgada, total
o parcialmente, bajo las modalidades de retiro de efectivo, en su caso, o pagos en favor de
terceros que realice el Emisor por cuenta del acreditado a través de la Red de Pagos con Tarjetas
que, para dichos efectos, opere la Cámara de Compensación para Pagos con Tarjetas.
“Tarjetas de Débito”: al medio de disposición emitido al amparo de un contrato de depósito de
dinero a la vista, que el Emisor otorga al depositante para que este, mediante la utilización
de dicho medio, pueda, además de realizar otras operaciones de retiro, disponer de los fondos
en depósito como pagos en favor de terceros que realice el Emisor por cuenta del depositante a
través de la Red de Pagos con Tarjetas que, para dichos efectos, opere la Cámara de
Compensación para Pagos con Tarjetas.
“Tasas de Descuento”: a cualquier cobro fijo, variable en función al monto o combinación de estos
que efectúa el Adquirente a los Receptores de Pagos, por cada operación de Pago con Tarjeta.
“Tarjetahabiente(s)”: Significa cualquier persona física o moral titular de un Medio de Pago,
con la que el Usuario tenga o llegue a establecer alguna relación y le sea aplicable el
Servicio otorgado por Peiix.
“Transacción”: Significará la operación efectuada a través del Sistema de Peiix al Medio de Pago
del Tarjetahabiente de conformidad con el formato de alta o Pagaré que el Tarjetahabiente
acepte y firme para el Usuario.
“Usuario o Receptor de Pagos”: a la persona física o moral que, con motivo de la celebración de
un Contrato, acepta Pagos con Tarjeta por medio de Lectores Peiix u otros dispositivos
conectados a la Red de Pagos con Tarjetas que Peiix ponga a su disposición, y es quien a su
vez inicia la solicitud de autorización a través de Peiix y recibe la aceptación o rechazo de esta,
a través del Sistema.
“Venta u Operación de Pago con Tarjeta”: Significa la operación que involucra la entrega de
recursos al Usuario, derivado de la aceptación que este haya hecho de una Tarjeta, para cubrir
alguna contraprestación cierta por el suministro de un bien, prestación de un servicio o por
cualquier otro concepto, mediante los cargos correspondientes en la cuenta vinculada a dicha
tarjeta y el abono del monto acordado en la cuenta del Usuario.
TÉRMINOS
A. EL SERVICIO
Términos y condiciones del servicio Peiix
1. General
1. El Servicio permite que el Usuario acepte pagos efectuados con Medios de Pago
presentes y no presentes, mediante Dispositivos Móviles. Con ocasión del Servicio de
aceptación de pagos efectuados con Medios de Pago, Peiix:
1. Recibirá del Usuario las solicitudes de autorización de pago con Tarjetas de los
Titulares de Marca que, de manera expresa y por escrito, Peiix haya notificado al
Usuario.
2. Enviará todas las solicitudes de autorizaciones recibidas a los distintos Emisores
para su posterior procesamiento en la Cámara de Compensación.
3. Recibirá respuestas de las solicitudes de Transacciones aprobadas o rechazadas
4. Liquidará al Usuario el importe neto de las Operaciones de Pago efectuadas con
Tarjetas, así: Ventas – Tasa de Descuento – Impuesto al Valor Agregado –
Devoluciones – Contracargos + Representaciones +/- Ajustes.
5. Tramitará administrativamente las Devoluciones y Ajustes; a solicitud expresa del
Usuario. No existirá reembolso de la Tasa de Descuento para las devoluciones
solicitadas después de las 23 horas del mismo día de realizada la Transacción.
6. Suministrará al Usuario los Lectores Peiix que este requiera.
7. Pondrá a disposición del Usuario servicio de soporte transaccional, para atender
solicitudes de disponibilidad y continuidad de los Servicios para la recepción y
procesamiento de pagos a través del Sistema de Peiix, bajo modalidad 7*24 (puede
variar).
De conformidad con los Términos, Peiix registrará los importes recibidos por Peiix en
virtud de las Ventas u Operaciones de Pago con Tarjeta realizadas a través del Servicio en la
Cuenta del Usuario (tras la deducción de las comisiones citadas en el apartado 9), y remitirá
dichos importes a la Cuenta designada por el Usuario de acuerdo con el apartado 22.
Al aceptar estos Términos, el Usuario confiere a Peiix una comisión mercantil de conformidad
con el Código de Comercio de los Estados Unidos Mexicanos, con el fin de que Peiix preste
el Servicio al Usuario. En específico, para recibir pagos por cuenta del Usuario y para
administrar fondos del Usuario de conformidad con los presentes Términos; así mismo, da su
autorización expresa e instruye a Peiix para (i) que se incluya(n) sus datos en la
base de datos de Peiix, (ii) solicitar información relacionada con su situación patrimonial y
operaciones de crédito, y (iii) administrar su información de acuerdo a las reglas para su
operación incluyendo el dar de alta afiliaciones en la Base de Datos Única (BDU) que maneja
Peiix para sus afiliaciones.
2. El Usuario accede al Servicio y a la Cuenta de Usuario a través de la Aplicación y
por medio de la Página Web. El Servicio debe ser utilizado a través de un Lector Peiix,
Internet o cualquier tipo de conexión que Peiix posea con el sistema interbancario lo
que da lugar
Términos y condiciones del servicio Peiix
a las Transacciones.
3. Peiix podrá en todo momento revisar o modificar el Servicio y en consecuencia los
presentes Términos. Peiix notificará al Usuario cualquier cambio con una antelación
razonable pero no menor a 10 días hábiles, los cuales serán comunicados en la
Página Web, por correo electrónico o por cualquier otro medio de notificación donde
exista contacto con el Usuario. No obstante, Peiix se reserva el derecho a aplicar dichos
cambios con efectos inmediatos para mantener la seguridad de sus sistemas o para cumplir
con las correspondientes leyes, reglamentos o normas emitidas por el Adquirente de Peiix
o por las Redes.
2. Condiciones para el uso del Servicio y limitaciones del mismo
1. Mediante la aceptación de los Términos, el Usuario reconoce que:
1. El Usuario cuenta con la capacidad suficiente para obligarse –si es una persona
física-, así como para obligar a la persona que representa; en el primer caso, tiene, al
menos, 18 años de edad y es residente de México.
2. Los pagos realizados a través del Servicio cumplen con los Términos, las leyes y
normas aplicables.
3. Le fue facilitado el contenido completo de los Términos y el clausulado del Contrato,
previo a asentar sus datos en este último documento y a recabar la firma correspondiente.
4. Cuenta con los permisos, licencias, concesiones y cualquier clase de autorización
gubernamental nacional e internacional necesaria para el desarrollo de sus Actividad
Comercial y/o el cumplimiento de las obligaciones contenidas en los Términos.
5. Cumple con la normatividad nacional e internacional aplicable en materia de i)
prevención de lavado de dinero y financiamiento al terrorismo, y ii) anticorrupción; y
ha implementado políticas internas para la identificación y aviso de operaciones
de sus consumidores que
puedan contravenir esas disposiciones, con la finalidad de prevenir que, en desarrollo
de su Actividad Comercial, resulte sujeto de los delitos establecidos por el Código
Penal Federal o sus correlativos en los Estados de la República Mexicana.
6. Conoce la Lista de Buenas y Malas Prácticas en Transacciones con Tarjeta
(descritas en este Apartado 2), y cumplirá a cabalidad las obligaciones establecidas
como de su cargo.
7. Cuenta con un Aviso de Privacidad que incorpora los términos del Aviso de
Privacidad de Peiix en lo que refiere al tratamiento y autorizaciones requeridos de sus
Consumidores para la ejecución del Contrato; ha puesto su Aviso de Privacidad a
disposición de sus Consumidores y, por tanto, estos conocen el alcance del mismo
y la forma en que serán utilizados sus Datos Personales; por tanto, por el presente, otorga
Términos y condiciones del servicio Peiix
su expresa autorización para que Peiix maneje y disponga de dichos Datos
Personales, en los términos establecidos en el Aviso de Privacidad.
8. En relación con sus actividades conforme al Contrato, ni Peiix, ni ningún agente,
afiliado, empleado u otra persona que actúe en su nombre, ha ofrecido, prometido,
dado o autorizado (i) el otorgamiento de ningún objeto de valor, (ii) reembolso, (iii)
recompensa, (iv) pago para generar influencias, (v) pagos de facilitación, (vi) dádivas
u (vii) otro pago ilícito al Usuario, con el objetivo de obtener o retener un negocio, recibir
una ventaja indebida o influenciar algún acto o decisión del Usuario.
9. Por la celebración del Contrato, no le ha encomendado o encomendará a Peiix,
ni este ha quedado o quedará facultado para realizar en nombre o a favor del Usuario,
de manera directa o indirecta, ningún trámite o gestión tendiente a la obtención
de licencia, autorización o factibilidad alguna, ante dependencias de Gobierno
Federal, Estatal o Municipal.
2. El Usuario deberá usar su nombre o el de su negocio, sea razón social o marca. El
nombre deberá ser verdadero y razonablemente descriptivo para identificar al Usuario
o a su negocio con claridad. Este nombre aparecerá como referencia en el reporte del
Medio de Pago con el que el Usuario recibe pagos a través del Servicio.
3. El Usuario no utilizará el Servicio para recibir pagos de mercancías y servicios que (i)
infrinja leyes locales, nacionales o internacionales, (ii) Artículos que contengan algún
tipo de droga ilegal; (iii) Venta de tabaco por internet; (iv) Venta de medicamentos y/o
“substancias milagro” por internet; (v) Actividades de tiempo compartido incluyendo
venta directa y revendedores (excepto cuentas nacionales o globales de prestigio sin
que sean resellers o distribuidores de la cadena de hotel, por ejemplo, Grupo Vidanta,
Palace Resorts), o que no son miembros de una organización afianzadora de la industria
de viajes o un agente autorizado; (vi) Comerciantes que prestan servicios por teléfono y
que reciban llamadas de los Tarjetahabientes u operen sin ninguna dirección física
permanente; (vii) Relativos a prostitución, servicios potencialmente sexuales como de
acompañantes y salas de masajes; (viii) Subastas por Internet; (ix) Servicios Futuros,
inversión en el vencimiento futuro de los bienes, inversión realizada en el vencimiento
futuro de los bienes / servicios ( >4 meses para la entrega) con la intención de obtener un
rendimiento sobre la inversión, por ejemplo: vinos, licores o inversión en madera así como
cambio o garantía de cheques; (x) Cobro de la deuda de servicios financieros con tarjeta
de crédito; (xi) Reestructuración de créditos o modificaciones a préstamos, así como
montos que no representan la venta de bienes y/o servicios de buena fe, es decir ventas
con fines de flujo de efectivo, auto cobros; (xii) Personas y Organizaciones que apoyen
al terrorismo; (xiii) Partidos Políticos; (xiv) Venta de productos y servicios relacionados
a la piratería o productos apócrifos; (xv) Esquemas piramidales fraudulentos (flor de
la abundancia, entre otros); (xvi) Agentes de trasmisores de dinero o recepción de
transmisión de dinero o casas de cambio o cambio de cheques; (xvii) Fabricación y venta
de armamento; (xvii) Agencias de adopción o agencias que cobran a padres adoptivos por
la colocación de bebés; y (xix) Aquellos que se encuentren prohibidos por exclusiva
discreción de Peiix, planteen cualquier duda desde un punto de vista de riesgos, quejas o
Términos y condiciones del servicio Peiix
de reputación. Peiix, a su exclusiva discreción, decidirá si considera el uso del Servicio por
parte del Usuario como un uso admisible o incluido en cualquiera de los productos o
servicios ofrecidos por Peiix y, por tanto, disconforme con los Términos. Para el caso
de Usuarios que acepten Tarjetas American Express, estarán prohibidos, adicionalmente
a los ya descritos, los giros de negocio que se listan a continuación: (i) Juegos de azar,
juegos de la suerte y/o juegos de azar en línea, incluyendo: Casinos con licencia
gubernamental; Apuestas, incluidos boletos de lotería, y fichas de juegos; (ii) Otros
Proveedores de Servicios de Pago; (iii) Servicios Financieros como compra / carga de
la tarjeta de valor almacenado y cheques de viajero, barcos de vapor y líneas de
cruceros y retiros de efectivo; (vi) Telecomunicaciones; (vii) Ventas Puerta a Puerta,
(viii) Operación desde un numero de Apartado Postal; y (ix) Operadores de Viajes Turísticos
que no son miembros de una organización afianzadora.
4. El Usuario no (i) exigirá límites mínimos de precio para la aceptación de un Medio de
Pago, (ii) aplicará precios superiores ni comisiones adicionales por el uso de un Medio de Pago
en relación con una Venta u Operación de Pago, ni (iii) realizará deducciones en efectivo
durante las Transacciones de pago, (iv) llevará a cabo Transacciones de pago en otros
territorios además de México y en otras monedas además de Pesos Mexicanos, (v) discriminará
entre Medios de Pago por cualquier motivo, (vi) presentará para su procesamiento o para su
crédito, directa o indirectamente, cualquier Transacción de pago no originada de una
Transacción de pago directa entre el Usuario y la persona física o moral titular de un Medio de
Pago, con el Tarjetahabiente, o cualquier Transacción de pago que el Usuario sepa o deba
saber que es fraudulenta o no autorizada por el Tarjetahabiente, (vii) presentará para su
procesamiento cualquier Transacción de pago que represente la refinanciación de una
obligación existente del tarjetahabiente, (viii) requerirá a cualquier tarjetahabiente a renunciar
a su derecho a un Desconocimiento de Cargo, (ix) procesará una compra de bienes y/o
servicios como varias Transacciones de pago.
5. El Usuario no podrá utilizar el Servicio para efectuar Transacciones con Tarjetas
pertenecientes al Usuario inscritas en nombre del Usuario.
6. En atención a que el Adquirente y las Redes imponen a Peiix ciertos límites con
respecto al volumen anual de Transacciones con Tarjetas para cada Usuario, ya
sean Tarjetas American Express, MasterCard y VISA, a través del uso del
Servicio, de hasta 100,000 USD, si el volumen anual de Transacciones cursadas con
ocasión del Servicio, para cualquier Usuario, supera este límite, o su equivalente en
Pesos Mexicanos, Peiix notificará al Usuario y le informará el procedimiento a seguir bajo
los términos de las reglas aplicables de los Participantes. Es entendido por el Usuario que,
en estos casos, Peiix podrá ser requerido para dejar de prestar el Servicio y dar por
terminado el Contrato. El Usuario deberá dar aviso inmediato a Peiix en caso de que prevea
que el monto máximo establecido en esta Sección será rebasado.
7. Si el Usuario se ha registrado en Peiix como una persona física y su volumen de
facturación anual relacionado con su Cuenta Peiix, y el número de pagos aceptados
por el Usuario o el uso de la Cuenta Peiix, en la opinión objetiva del equipo de
Términos y condiciones del servicio Peiix
riesgos de Peiix, sugiera que las operaciones del Usuario constituyen actividades
empresariales, Peiix puede requerir al Usuario para que se registre como una persona
física con actividades empresariales. En caso de que el Usuario no cumpla con dicho
requerimiento, Peiix podrá dar por terminado el Contrato y suspender la prestación de
los Servicios.
8. El Usuario no podrá remitirse o referirse a Peiix, al Adquirente o las Redes, al
declarar la elegibilidad de sus bienes y / o servicios o los bienes y servicios que ofrece
para Venta.
9. Con la aceptación de los Términos, el Usuario otorga a Peiix un mandato general para
contratar por su cuenta servicios, programas, funcionalidades, mejoras, seguridades y,
en general, habilitar a su nombre todos aquellos desarrollos o servicios particulares
ofrecidos por los Participantes, que redunden en la mejora, actualización o cumplimiento
del Servicio frente a los requerimientos y/o regulaciones de las Redes y/o, en general, los
Participantes. Con la concesión del presente mandato, el Usuario faculta a Peiix para llevar
a cabo todas las tareas o actividades necesarias en procura de la certificación,
implementación, realización de pruebas y, en general, puesta en producción de esos
servicios, programas, funcionalidades, mejoras, seguridades y/o desarrollos que resulten
contratados. Tratándose de herramientas de certificación o seguridad Peiix notificará al
usuario para evitar duplicidad de uso en caso de que éste tenga implementado sistemas
similares. Este mandato general no requerirá de la refrendación particular del Usuario en
cuanto a los términos de la contratación que realice Peiix por cuenta del Usuario, salvo en
aquellos casos en que el servicio, programa, funcionalidad, mejora, seguridad y/o desarrollo
particular contratado implique la asunción de una obligación de pago, adicional al pago de
las Tasas de Descuento y/o Comisiones conocidas y aceptada por el Usuario con la firma
del Contrato.
Sin perjuicio de lo anterior, y para el caso específico del “Programa de Pagos Diferidos sin
Intereses” (Meses Sin Intereses), que permite a los Tarjetahabientes emitidas por Emisores
participantes en el programa diferir el pago del importe de sus compras o consumos
efectuados a favor del Usuario, en mensualidades fijas, según el plazo acordado, el Usuario
reconoce que i) existe una Comisión particular a favor de Peiix por las gestiones que realiza
en su nombre para la habilitación del Programa y acepta pagarlas en los términos
establecidos en el Contrato; y que, ii) para que le sea habilitada la opción de pagos diferidos,
deberá operar bajo los conceptos, términos y condiciones estipulados por su cuenta por
parte de Peiix en el respectivo convenio, y para lo cual todas las transacciones serán
operadas por Peiix bajo el número de afiliación y Adquirente definidos en el respectivo
convenio.
El Programa Meses Sin Intereses no aplicará a tarjetas de crédito empresariales y/o tarjetas
de débito o cualquier tipo de tarjetas privadas, así como las tarjetas emitidas por Emisores
que no hagan parte del Programa.
Términos y condiciones del servicio Peiix
10. Buenas y Malas Prácticas en Transacciones con Tarjeta. El Usuario está obligado
en todo momento a:
1. Aceptar cualquier Tarjeta, sea de crédito, débito o prepago; Visa, MasterCard,
Carnet, American Express, JCB, Discover y/o Diners Club; sin discriminación alguna.
2. Abstenerse de:
1. Aumentar cantidad alguna al precio de los bienes o servicios ofrecidos
por el Usuario como condición para aceptar como medio de pago una
Tarjeta de crédito o débito. Esta restricción no prohíbe que el Usuario
ofrezca descuentos en caso de que el medio de pago sea efectivo.
2. Procesar Transacciones con el propósito de obtener o entregar, directa o
indirectamente, dinero en efectivo al Tarjetahabiente.
3. Almacenar o conservar datos del Tarjetahabiente, después de la autorización
de la Transacción, adicionales al nombre, número de Tarjeta y fecha de
expedición.
4. Duplicar Transacciones; el Usuario será responsable por la duplicación de
Transacciones, así como de cualquier Contracargo que pueda resultar
como consecuencia de la duplicación.
5. Procesar Transacciones que (i) no sean originadas como resultado de una
operación directa entre el Usuario y un Tarjetahabiente; (ii) el Usuario
tenga conocimiento o deba tener conocimiento de que es fraudulenta
o que no se encuentra autorizada por el Tarjetahabiente; (iii) con una
Tarjeta que no esté autorizada; y/o (iv) mediante una Tarjeta de débito o
crédito reportada como perdida, robada o en cualquier forma inválida.
6. Depositar pagarés de venta que representen el refinanciamiento de una
obligación del Tarjetahabiente.
7. Copiar, almacenar o resguardar dato alguno de la Tarjeta, ni el llamado
código de seguridad CVV o CVC2, ya sea en documentos físicos o discos
magnéticos.
3. Divulgar a sus consumidores cualquier limitación o restricción en la devolución de la
mercancía o cancelación del servicio al momento de la Transacción.
4. Incluir la cantidad total de bienes y servicios adquiridos en una sola Transacción.
3. Cuenta y conexión al Servicio
1. Para utilizar el Servicio el Usuario deberá registrar y crear una cuenta en Peiix (“la
Cuenta de Usuario o Cuenta Peiix”). El Usuario estará obligado a proporcionar
información precisa y completa al registrar la Cuenta Peiix, en el entendido que
Peiix utilizará dicha información únicamente para los fines del Servicio. Si dicha
información cambiara, el Usuario está de acuerdo en notificar inmediatamente a Peiix
dichos cambios actualizando su Cuenta Peiix. Si el Usuario no proporciona a Peiix
Términos y condiciones del servicio Peiix
información correcta, veraz, completa y actualizada, Peiix puede no ser capaz de proveer
el Servicio o cumplir los Términos sin que esto represente incumplimiento por parte de
Peiix, facultando al efecto a este último a bloquear temporalmente la Cuenta Peiix del
Usuario, la posibilidad de negar acceso al Servicio y/o dar por terminado el Contrato.
2. Para verificar que el Usuario es el titular de la Cuenta, Peiix tiene el derecho de
dirigir las preguntas necesarias al Adquirente en ese sentido. El Usuario reconoce
y acepta que Peiix tiene ese derecho y consiente en tomar todas las medidas
razonables para ayudar a Peiix en esta materia.
3. Si las acciones a las que refiere el apartado 3.2 revelan o si de cualquier otra forma
llega a conocimiento de Peiix, podrá restringir, limitar o negar el acceso a determinadas
funcionalidades del Servicio cuando lo considere necesario para mitigar riesgos; sin
embargo, dichas medidas deberán ser proporcionales al riesgo identificado y, siempre
que sea posible, limitarse únicamente a las funcionalidades afectadas, manteniendo
operativas aquellas que no representen riesgo para Peiix o para terceros.
En los supuestos previstos en el presente numeral, Peiix deberá informar al Usuario las
causas de la restricción y, en su caso, el plazo estimado para su levantamiento, salvo
que exista prohibición legal para hacerlo.
4. Cuando el Usuario se haya registrado para solicitar la prestación del Servicio,
deberá entregar documentación para que Peiix pueda llevar a cabo el estudio pertinente
determinado por sus políticas de riesgo y cumplimiento, y de esta manera esté seguro
de que el Usuario ha cumplido con todos los requisitos necesarios de acuerdo
con las leyes aplicables en materia de lavado de dinero. Peiix puede realizar una revisión
crediticia sobre el Usuario. El Usuario consiente en que Peiix puede obtener
información crediticia, lo autoriza plenamente en ese aspecto para que lleve a cabo
esa revisión o consultas crediticias necesarias.
5. Peiix determinará libremente y a su exclusiva discreción, si concede acceso al
Servicio al Usuario. Peiix solamente quedará vinculada por los Términos una vez que
haya decidido otorgar acceso al Servicio al Usuario. Peiix enviará una confirmación
a través de correo electrónico u otro medio, confirmando que el Usuario podrá empezar
a utilizar el Servicio, y aprobando el registro de una cuenta en el Sistema de Peiix (la
"Cuenta Peiix") por parte del Usuario, misma que permite al Usuario la utilización del
Sistema. Sin perjuicio de lo anterior, Peiix estará facultado para dar por terminado el
Contrato y, en consecuencia, suspender la prestación del Servicio al Usuario, en caso de
que este último no finalice en debida forma su proceso de onboarding.
6. Los requisitos técnicos del dispositivo móvil del Usuario, según establece Peiix, se
encuentran establecidos en la Página Web. Peiix no garantiza que el Servicio sea
compatible y por ende tenga conexión con dispositivos móviles o lectores
de otros proveedores si no se encuentran en la lista de dispositivos compatibles.
Términos y condiciones del servicio Peiix
El uso de un dispositivo móvil al que se hayan manipulado sus características
tecnológicas, por ejemplo, mediante “jailbreak”, para usar el Servicio queda expresamente
prohibido y constituye una violación a los Términos y es motivo para la suspensión
definitiva de la Cuenta Peiix del Usuario.
7. En caso de que se deban hacer ajustes o modificaciones al Sistema por disposiciones
legales o cambios en la regulación aplicable a los Términos, éstos correrán a
cargo de Peiix informándose según aplique con las disposiciones modificadas en un
plazo de al menos 10 días hábiles contados a partir de la fecha en la que deban hacerse
efectivos estos cambios.
8. La capacidad del Usuario de acceso al Servicio a través de un dispositivo móvil,
teléfono o internet, dependerá de los servicios de acceso y transferencia de datos
en Internet recibidos por terceros contratados por el Usuario. El Usuario será el
único responsable del pago de dichos costos. La utilización del Servicio por el Usuario
también podrá estar sujeta a los Términos y Condiciones de uso del servicio emitidos
por el proveedor de servicios de telefonía móvil y/o conexión a internet, sin que
dichos factores puedan ser atribuibles a Peiix.
El Usuario entiende, autoriza y acepta que Peiix podrá compartir información acerca
del Usuario, su solicitud de Servicio (incluido el resultado de aprobación o rechazo) y su
Cuenta, con el Adquirente del Usuario, las Redes y, en general, con cualquiera de los
Participantes del Sistema, en referencia a aspectos relacionados con el Servicio y/o con los
Pasivos del Usuario. Esta autorización se extiende a compartir información sobre
Transacciones, perfil y operación del negocio del Usuario, con fin de cumplir requerimientos
u obligaciones normativas, reglamentos aplicables, y fines de administración,
mantenimiento, mejora continua y administración del riesgo.
4. Requisitos de contraseña y protección de datos de acceso, etc.
1. El Usuario se obliga a cumplir con los procedimientos e instrucciones de seguridad
establecidos por Peiix, los cuales podrán ser modificados o actualizados en cualquier
momento, con respecto a la contraseña del Usuario y otra información de acceso.
Dichos procedimientos e instrucciones de seguridad podrán ser consultados en la Página
Web.
2. Es responsabilidad del Usuario garantizar que el número y la contraseña de su Cuenta
Peiix, así como otra información de acceso al Servicio (la "Información de la Cuenta
Peiix") será conservada por el Usuario en un lugar seguro, obligándose a que
dicha información permanezca inaccesible a terceros, siendo el único y exclusivo
responsable de la guarda y custodia de la misma.
Términos y condiciones del servicio Peiix
3. Peiix asume que el Usuario es el remitente de las órdenes de pago y de otras
instrucciones enviadas utilizando la Información de la Cuenta Peiix y la
contraseña del Usuario, considerándose como validas hasta en tanto no reciba
notificación expresa y por escrito de lo contrario. Por ello, el Usuario reconoce
y acepta que deberá informar inmediatamente a Peiix a través de la Página Web o a
través de la Aplicación, si tuviera algún motivo para pensar que una persona no autorizada
ha accedido o puede tener acceso a la Cuenta Peiix debiendo además cambiar la
información de acceso de manera inmediata.
5. Suministro y Soporte de Lectores Peiix:
1. Para el pago del precio de los Lectores Peiix, el Usuario acepta que Peiix retenga las
cantidades a que haya lugar derivadas de las Transacciones efectuadas con dichos
Lectores Peiix, hasta que se cubra la totalidad del precio correspondiente a los
mismos, según dicho precio esté publicado en la Página Web, para la(s) versión(es)
de Lector(es) Peiix adquirido(s) por el Usuario. En caso de terminación del Contrato sin
haberse liquidado el total insoluto del importe de los Lectores Peiix, el Usuario podrá solicitar
el importe retenido contra la devolución de los Lectores Peiix en adeudo, siempre que
estos se presenten en óptimas condiciones físicas y de funcionamiento, salvo por el desgate
natural derivado de su uso; la devolución de ese importe se realizará en un plazo máximo
de 30 (treinta) días desde la restitución efectiva de los Lectores Peiix.
2. La política de cambio, reembolso por defecto, reparaciones y garantía de los
Lectores Peiix es la siguiente:
i. El Usuario cuenta con un periodo de 90 (noventa) días naturales, contados a partir
de la fecha de compra, para solicitar el cambio o reparación por defecto del
Lector Peiix; esto, únicamente para el caso de falla mecánica o electrónica, y
siempre que al Lector Peiix se le haya dado un uso convencional.
ii. Peiix determinará, a su criterio, si es aplicable, o no, el cambio o reparación del Lector
Peiix. En caso de no resultar aplicable el cambio, el precio de los Lectores Peiix
y/o de su reparación, se pagará bajo el mismo sistema retenciones aquí previsto.
iii. Sin perjuicio de lo anterior, el cambio o reparación del Lector Peiix no resultará
procedente en aquellos casos en que Peiix evidencie que:
Ya está fuera del período de garantía.
Fue operado de manera incorrecta por el Usuario, le ha caído líquido, o ha
sufrido daño u otros problemas que obedezcan a la calidad de la terminal.
Fue expuesto a alto voltaje externo, rayos y/u otros factores ambientales severos.
Le fueron instaladas aplicaciones, sistemas operativos o configuraciones no
autorizadas en la terminal, y/o por tanto, fue víctima de ataque de virus o código
malicioso.
Términos y condiciones del servicio Peiix
Fue transportado o almacenado de manera inadecuada.
Fue alterado, reparado o se le realizó mantenimiento por cuenta del
Usuario sin autorización de Peiix.
Fue utilizado en condiciones distintas o para propósitos diferentes a aquellos
para los que fue diseñado y/o suministrado; o por fuera de las condiciones
incluidas en el instructivo de uso que lo acompaña.
iv. Durante el tiempo que tome Peiix para determinar la procedencia de cambio o
reparación, proporcionará al Usuario un Lector Peiix provisional; en caso de daño,
pérdida o extravío del mismo, el Usuario pagará su precio bajo el sistema de
retenciones aquí previsto.
3. Peiix prestará servicio de soporte al funcionamiento de los sus servicios, a través del
CAT Peiix (atención telefónica), en horario de 9 a 21 horas, de lunes a viernes, y de
10 a 16 horas los sábados, exceptuando días feriados oficiales según la Comisión
Nacional Bancaria y de Valores, en referencia a: (i) Problema técnico; (ii) Servicio de
comunicación para envío de transacciones; (iii) Reseteo/desbloqueo de usuarios; (iv)
Bloqueo y estatus de afiliaciones; (v) Soporte operativo; (vi) Conciliación; (vii) Aclaraciones;
y (viii) Archivos electrónicos entregables.
4. Una vez recibido el Lector Peiix, el Usuario asume todo tipo de responsabilidad
por el uso que se dé al mismo, esto, no solo desde el punto de vista del resguardo y
custodia física, así como del funcionamiento técnico de la terminal, sino de su
utilización para fines o giros comerciales distintos a los informados a Peiix en el momento
de su vinculación. En tal consideración, el Usuario:
1. Asumirá los costos de reparación y/o reposición de los Lectores Peiix, incluso
asociados a pérdida, robo o daño atribuible a terceros; y
2. Mantendrá indemne a Peiix, de todas y cualquier consecuencia legal o pecuniarias
que pudiere derivarse de usos extraños o ajenos al giro comercial registrado
por el Usuario ente Peiix o, incluso, usos calificables como de irregulares, ilegítimos o
ilegales, así como de cualquier acción de tipo legal, policial o administrativo, que pudiere
adelantarse por cualquier tercero o autoridad competente, en contra de Peiix o de sus partes
relacionadas, con ocasión de esos usos irregulares, ilegítimos o ilegales.
6. Obligaciones del Usuario relativas al uso del Servicio
1. Además de las disposiciones establecidas en el apartado 3.1, el Usuario estará
obligado a informar y mantener actualizado a Peiix de los domicilios de todas las
oficinas y centros de negocio, todos los nombres comerciales utilizados, y una
completa descripción de los productos y/o servicios suministrados u ofrecidos al
público por el Usuario. Si cualquier información fuera imprecisa, incompleta o en caso
Términos y condiciones del servicio Peiix
de cambios no se actualizara a la brevedad, Peiix tendrá derecho a cerrar la Cuenta
Peiix y a cancelar el acceso del Usuario al Servicio.
2. El Usuario deberá en todo momento cumplir con las leyes aplicables y deberá, cuando
así lo requiera Peiix, proporcionar la asistencia razonable que es necesaria para
que Peiix cumpla con las leyes aplicables, las reglas emitidas por el Adquirente
de Peiix o las Redes, y otras obligaciones de Peiix. El Usuario consiente en
cumplir las normas relacionadas con el Servicio que los Participantes emitan en su
condición de tal, en cualquier momento de la ejecución del Contrato.
3. El Usuario indemnizará a Peiix o a cualquier parte relacionada de Peiix
(incluyendo filiales, subsidiarias o controladoras) por cualquier reclamación presentada
por un tercero contra Peiix derivada de la utilización del Servicio por parte del
Usuario en contravención de los Términos o en infracción de las leyes o reglamentos
aplicables, o de las normas emitidas o de otra forma aplicadas por el Adquirente
de Peiix o las Redes.
Quedan expresamente excluidos de la responsabilidad del Usuario aquellos
Contracargos que tengan su origen en fallas del Sistema de Peiix, de los Adquirentes,
de las Redes de Pago, en errores de procesamiento, en accesos no autorizados no
atribuibles al Usuario, o en cualquier causa ajena a su control razonable, sin perjuicio
del deber del Usuario de colaborar en los procesos de aclaración o investigación
correspondientes.
4. El Usuario deberá notificar inmediatamente a Peiix cualquier procedimiento de
insolvencia, quiebra, averiguación, acción o procedimiento similar iniciado contra el
Usuario o cualquier propietario del Usuario. O bien, si se da cuenta de cualquier
incumplimiento y/o violación de los Términos del Servicio o de la ley aplicable respecto
de tratamiento de datos personales.
5. El Usuario garantiza que todas las Transacciones de pago son de buena fe y que tendrá
autorización expresa del Tarjetahabiente para los cargos periódicos recurrentes,
contando previamente con el respectivo contrato de servicio debidamente firmado y
teniendo establecido expresamente en este: i) los términos y condiciones relativos
a autorización específica del Tarjetahabiente para la renovación automática, ii) su
autorización sobre los servicios y cargos periódicos y recurrentes, y iii) las políticas de
cancelación o devolución determinada libremente por el Usuario, en la cual deberá
constar que es posible la cancelación dentro de un plazo máximo no mayor a 15
(quince) días naturales previos al cargo de la Tarjeta del Tarjetahabiente con la siguiente
Transacción programada. Es entendido que cualquier modificación a estos contenidos
deberá ser informada a Peiix con por lo menos 5 (cinco) días hábiles de anticipación a su
entrada en vigor. El Usuario deberá otorgar al Tarjetahabiente como mínimo la siguiente
información: i) la fecha de cancelación, ii) número de reporte y iii) nombre de quien recibió
Términos y condiciones del servicio Peiix
la cancelación. En el evento de que no se cumpla lo anteriormente descrito en este inciso,
el Usuario acepta que Peiix determine discrecionalmente las acciones a realizar respecto
los Contracargos y cualquier otra acción relacionada.
6. El Usuario deberá mostrar de forma visible a sus clientes en su establecimiento
comercial, cualquier elemento promocional de Peiix. Dicho material será
proporcionado por Peiix y puede incluir, pero no se limita a calcomanías para su
empresa, tienda o ventana del automóvil con el logotipo de Peiix y/o de las Redes,
o bien, carteles, anuncios o folletos que deben ser exhibidos por requisito legal, de las
Redes o de Peiix. A partir de la celebración del Contrato, se deberá especificar que los
Servicios y el Sistema por el cual se realizarán las Transacciones, son, y así deberán
constar textualmente: “PROPIEDAD EXCLUSIVA DE PEIIX Y POR LO TANTO SON LOS
ÚNICOS AUTORIZADOS PARA OPERAR Y HACER USO DEL MISMO”, y que en los
estados de cuenta de los usuarios los cargos aparecerán como se describe en la Carátula
de los Términos en el apartado “Identificador para operaciones en estados de cuenta”.
7. El Usuario es el único responsable del servicio al cliente relacionado con los bienes y/o
servicios que ofrece, incluyendo sin limitar el precio, surtido de pedidos, cancelación de
pedidos, devoluciones, reembolsos, ajustes, descuentos, funcionalidad, garantía,
soporte técnico y retroalimentación en relación con las experiencias con su personal,
políticas o procesos, por lo que se obliga a sacar en paz y a salvo a Peiix respecto
de controversias derivadas de los mismos, coadyuvando en todo momento con Peiix
para su solución oportuna.
8. El Usuario se obliga a obtener del Tarjetahabiente la autorización para realizar la
Transacción con la Tarjeta a través de lectura de chip, nip o banda, captura de datos en
internet o domiciliación de pagos, además de obtener y validar la firma autógrafa
del Tarjetahabiente cuando el tipo de Transacción (tarjeta presente) lo permita y
conservar cualquier comprobante generado de la Transacción con el Tarjetahabiente.
9. No obstante lo establecido en el punto 6.8., el Usuario se obliga a abstenerse de
almacenar cintas magnéticas o datos de CVV2/CVc2/CID después de la autorización
de la Transacción, por lo que, después de la autorización de la Transacción, el
Usuario solo podrá conservar el nombre del Tarjetahabiente, número de Tarjeta y
fecha de expedición, liberando a Peiix de cualquier responsabilidad derivada del
incumplimiento al presente numeral.
10. El Usuario asumirá el pago de los cobros adicionales que realicen las Redes a Peiix
en asocio a la operación de los primeros, tales como el costo de ingreso y/o el costo por
adherir a Códigos de Categoría Mercante (Merchant Category Code o MCC por sus
siglas en inglés) calificados como de Alto Riesgo para las Redes, quienes exigen la
inscripción de dichos comercios a tales MCC en la medida en que el giro ordinario de sus
negocios se encuadre en su descripción. Estos pagos serán realizados de acuerdo a lo
indicado en los manuales de las Redes, disponibles para consulta en sus sitios web.
Términos y condiciones del servicio Peiix
Previo a la implementación de las acciones de registro que generen un cargo al
Usuario, Peiix deberá notificarle el importe y tiempos para cubrir el pago, y será el
Usuario quien determine continuar o no con dicho registro o proceso que genera el
cargo requerido por las Redes.
En el supuesto que el Usuario decida no realizar el pago o no se haga de manera
oportuna, Peiix podrá suspender o cancelar el servicio en tanto no se complete el
proceso de registro ante las Redes.
11. El Usuario asumirá el costo de los desarrollos, certificaciones, y/o demás actividades
requeridas para implementar los nuevos requerimientos regulatorios, operacionales o
de seguridad que sean de obligatorio cumplimiento, sea por parte de las Autoridades
o de los Participantes, así como de sus actualizaciones posteriores.
Dentro de los plazos informados en los respectivos requerimientos, el Usuario tendrá la
libertar de aceptar o rechazar los costos propuestos por Peiix, en el entendido que al ser
rechazados o de no cumplirse los tiempos de pago, Peiix podrá suspender o cancelar el
servicio en tanto no se implementen dichos procesos o se liquiden los pagos.
12. Asumir el pago de cualquier multa impuesta a Peiix por las Redes y/o por las
Autoridades como consecuencia de o en asocio al incumplimiento de las instrucciones
contenidas en los requerimientos mencionados en los presentes Términos, incluyendo
aquello bajo el numeral anterior, siempre que ese incumplimiento sea atribuible al
Usuario.
Peiix podrá compensar y, por tanto, deducir el monto de esas multas o penalidades
de los abonos futuros que le corresponda efectuar al Usuario y/o ejecutar el Fondo de
Reserva.
En ningún caso el Usuario será responsable por sanciones derivadas de actos u
omisiones imputables a Peiix, a terceros ajenos al control del Usuario o a cambios
regulatorios generales no vinculados directamente con su operación.
13. El Usuario se obliga a colaborar de manera oportuna y diligente con Peiix en los
procedimientos de atención, gestión y defensa de Contracargos, proporcionando la
documentación, evidencias e información que razonablemente le sean requeridas
dentro de los plazos establecidos por las Redes de Pago o Adquirentes.
El Usuario indemnizará y mantendrá en paz y a salvo a Peiix frente a cualquier
reclamación, sanción, multa o responsabilidad económica derivada de Contracargos
cuando estos sean consecuencia directa de actos u omisiones imputables al Usuario.
En ningún caso el Usuario será responsable de indemnizar a Peiix por Contracargos,
pérdidas o reclamaciones que se originen en fallas técnicas, operativas o de seguridad
Términos y condiciones del servicio Peiix
imputables a Peiix, a las Redes de Pago, a los Adquirentes o a terceros ajenos al control
del Usuario, ni por eventos de fuerza mayor o caso fortuito.
7. Propiedad intelectual
1. Peiix es el único propietario de los Derechos de PI concernientes al Servicio y el
Sistema, y nada en estos Términos será interpretado como una concesión transferida
de Derechos de PI hacia el Usuario. El Usuario no podrá copiar, imitar o hacer
uso de los Derechos de PI sin previo aviso y consentimiento escrito de Peiix.
2. Peiix le concede al Usuario una licencia personal, limitada, no exclusiva, revocable e
intransferible (sin derecho a sublicenciar) para acceder de forma electrónica y hacer uso
del Servicio con el objetivo de aceptar pagos efectuados con las Tarjetas.
3. Sin el consentimiento previo por escrito de Peiix, se le prohíbe estrictamente
al Usuario: (i) transferir cualesquiera derechos que le hayan sido otorgados en virtud
de los presentes Términos a una tercera parte; (iii) acceder o supervisar cualquier
contenido, material o información sobre cualquier sistema de Peiix, manualmente o
con medios automatizados tales como robots, spiders, scrapers, etc.; (iv) copiar, reproducir,
alterar, modificar, crear trabajos derivados, mostrar públicamente, publicar nuevamente,
subir, colgar, transmitir, revender o distribuir cualquier forma de contenido, material
o información de Peiix; (v) violar las restricciones en cualquier exclusión del Servicio, eludir
cualquiera de las limitaciones técnicas del Servicio, utilizar cualquier herramienta para
habilitar funciones o características que están deshabilitadas de cualquier otro modo en
el Servicio, o descompilar, desmontar o utilizar ingeniería inversa en el Servicio; o bien
(vi) utilizar el Servicio para fines diferentes al permitido en virtud de los presentes Términos.
4. El Usuario podrá generar, enviar o subir contenido del Usuario siempre en relación
con el uso del Servicio (el “Contenido del Usuario”). El Usuario mantendrá todos
los derechos sobre el Contenido del Usuario siempre sujeto a los derechos que
concede a Peiix al aceptar los Términos. El Usuario acepta que no enviará ni subirá
Contenido del Usuario al Servicio, salvo que haya sido expresamente autorizado por Peiix
y siempre que dicho Contenido del Usuario haya sido creado por el mismo Usuario, o
tenga permiso del propietario de los derechos de autor para hacerlo. Para cualquier
Contenido del Usuario que envíe o suba al Servicio, el Usuario otorga a Peiix y a sus
filiales, y sucesores un derecho a nivel mundial, no exclusivo, libre de royalties, totalmente
pagado, transferible y sub licenciable para utilizar, reproducir, modificar, adaptar, publicar,
preparar trabajos derivados, distribuir, realizar y mostrar públicamente dicho Contenido del
Usuario por todo el mundo, en cualquier medio, con el fin de proporcionar y fomentar el
Servicio y la actividad de Peiix. El Usuario podrá modificar o eliminar su Contenido del
Usuario a través de su Cuenta Peiix o terminando su Cuenta Peiix. El Usuario acuerda no
enviar ni subir a los Servicios o colgar, transmitir, distribuir o difundir de cualquier otro modo
a través de los Servicios cualquier material que: (i) sea falso, engañoso, ilegal, obsceno,
Términos y condiciones del servicio Peiix
indecente, libidinoso, pornográfico, difamatorio, calumnioso, amenazante, embarazoso,
odioso, abusivo o incendiario; (ii) aliente conductas que serían consideradas un delito penal
o que den origen a responsabilidad civil; (iii) incumpla cualquier deber hacía, o los derechos
de, cualquier persona o entidad, incluidos los derechos de publicidad o privacidad; (iv)
contenga datos corruptos o cualesquiera otros ficheros dañinos, nocivos o destructivos; (v)
anuncie productos o servicios que compitan con los productos y servicios de Peiix o de
sus socios; o (vi) a juicio de Peiix, sea objetable, restrinja o impida a cualquier persona
o entidad utilizar o disfrutar de cualquier parte de los Servicios, o que pueda exponer a
Peiix, a sus filiales o usuarios a daño o responsabilidad de cualquier naturaleza. Aunque
Peiix no tiene ninguna obligación de emitir, editar o supervisar cualquier Contenido
del Usuario, Peiix se reserva el derecho, y tiene absoluta discreción, para solicitar la
eliminación, emisión, o edición de cualquier Contenido del Usuario que contravenga la Ley
Aplicable, resulte ofensivo, indecente u objetable. Peiix no se responsabiliza ni asume
ninguna responsabilidad por ningún Contenido del Usuario, incluidos cualquier pérdida
o daño o perjuicio asociado a los Contenido del Usuario.
5. Los productos de la marca, queda establecido que todas y cada una de las Marcas que
amparan a los Servicios y el Sistema son marcas registradas, por lo que todos los
derechos derivados de las mismas son y deberán en todo momento ser considerados
como propiedad única y exclusiva de Peiix y/o de sus accionistas o empresas
relacionadas, motivo por el cual, el Usuario en este acto se obliga a abstenerse de registrar
y/u obtener el registro de las Marcas, nombres comerciales, logos y demás símbolos
propiedad de Peiix o que se refieran a ésta; también se abstendrá de registrar y/u obtener
el registro, de marcas, nombres comerciales, logos y demás símbolos que se asemejen en
grado de confusión a aquellos propiedad de Peiix dentro y fuera del territorio nacional.
8. Cuenta Bancaria
1. Los fondos acreditados al Usuario serán abonados a la Cuenta designada por el
Usuario de conformidad con el apartado 23.
2. Los fondos recibidos por Peiix por cuenta del Usuario en ejecución del Servicio
pueden ser acumulados con fondos recibidos de forma similar por cuenta de otros Usuarios,
y pueden ser mantenidos en una o varias Cuentas en un banco o bancos seleccionados
para este propósito por Peiix.
9. Cuentas inactivas
Si no se produjera ninguna actividad en una Cuenta Peiix durante, al menos, dos años
consecutivos y el Usuario tuviera saldo a su favor en la Cuenta Peiix, Peiix notificará esta
situación al Usuario mediante correo electrónico, y le permitirá mantener la Cuenta Peiix activa
o cerrarla y retirar cualquier saldo pendiente de la Cuenta de Usuario. Si Peiix no recibe ninguna
respuesta del Usuario en el plazo de noventa (90) días naturales a partir de la fecha de envío,
podrá cerrar automáticamente la Cuenta de Usuario y los fondos del Usuario allí disponibles
Términos y condiciones del servicio Peiix
quedarán sujetos al destino que determine la ley aplicable al caso, por lo que se establece
que, para cantidades no reclamadas, que en el transcurso de tres años no hayan tenido
movimiento por depósitos o retiros y, después de que se haya dado aviso por escrito, en el
domicilio del Usuario que conste en el expediente respectivo, deberán ser abonados en una
cuenta global que llevará Peiix, teniendo la posibilidad de entregar o abonar nuevamente ese
importe al Usuario si este hiciere la respectiva solicitud en los términos de la ley.
Conservándose por 3 (tres) años más en esa cuenta global, los recursos abandonados
por el Usuario prescribirán en favor del patrimonio de la beneficencia pública y, en la medida
permitida por la ley, pasarán a Peiix.
10. Condiciones de pago
1. El uso del Servicio se encuentra sujeto a determinadas Comisiones conforme se
detallan en la Página Web, y serán actualizadas por correo electrónico en cualquier
momento. Por cada Operación de Pago con Tarjeta o Transacción realizada por
Peiix, se generará una Comisión a favor de Peiix, la cual está sujeta al pago de IVA.
Peiix tiene derecho a modificar las Comisiones conforme al apartado 30 siguiente.
2. Peiix estará facultado para retener, descontar o compensar, total o parcialmente,
cualquier cantidad que el Usuario adeude a Peiix derivada de Contracargos,
devoluciones, comisiones, penalidades, multas, ajustes operativos o cualquier otra
obligación económica prevista en los presentes Términos, siempre que dichas
cantidades sean ciertas, exigibles y directamente atribuibles al Usuario.
Peiix en todo momento deberá notificar al Usuario de manera clara el concepto, monto
y fundamento de la retención correspondiente.
Las retenciones o compensaciones que realice Peiix deberán estar basadas en el
monto de la obligación pendiente y no excederán en ningún caso el importe necesario
para cubrir el adeudo correspondiente, obligándose Peiix a liberar de manera inmediata
cualquier excedente una vez cubierto dicho monto.
Las compensaciones se realizarán exclusivamente respecto de los fondos disponibles
en la Cuenta Peiix del Usuario titular del presente Contrato y/o del fondo de reserva,
sin afectar cuentas, saldos, ventas futuras o recursos pertenecientes a sociedades
afiliadas, relacionadas o terceros, salvo que exista consentimiento expreso y por escrito
del Usuario.
La retención o compensación de fondos conforme al presente numeral no constituirá
penalidad, sino un mecanismo de garantía de cumplimiento de las obligaciones
económicas del Usuario, sin perjuicio del derecho de las Partes de ejercer las acciones
legales que conforme a derecho correspondan.
Términos y condiciones del servicio Peiix
3. Todas las Comisiones serán cargadas al Usuario junto con la transmisión del importe
de la Cuenta Peiix a la Cuenta.
4. Todos los impuestos y contribuciones que en su caso se generen con
motivo de los Términos correrán por cuenta y a cargo de la Parte que de acuerdo con
las disposiciones fiscales vigentes deba cubrirlas. Todas las erogaciones por
honorarios y gastos de asesores relacionados con los Términos deberán ser pagados
por cada una de las Partes que los originó.
5. La Comisión por el Servicio de Peiix será la pactada en el contrato de servicio Peiix por
Transacción. En caso de activar el servicio de Meses Sin Intereses, el Usuario deberá
pagar una Comisión adicional según el plan de pagos diferidos que seleccione y
conforme a la siguiente tabla, en el entendido de que dicha Comisión puede variar de
acuerdo con la negociación especifica que se lleve a cabo con el Usuario y resulte
aceptada por las Partes en el Contrato, a título de condiciones comerciales.
El Usuario acepta pagar una Comisión adicional, en los términos previamente
acordados en el Contrato, porque reconoce que el Emisor de las Tarjetas con las que se
realicen las Transacciones bajo este programa descontará diariamente a Peiix lo
pertinente a las comisiones acordadas en el Convenio celebrado por Peiix por cuenta
del Usuarios para acceder al Programa.
Con la aceptación de los Términos, el Usuario autoriza expresamente a Peiix a i) cobrar
las precitadas Comisiones adicionales y/o cualquier otro cargo o cantidad debida bajo la
reglamentación del Programa o exigible por ley, y a ii) compensar esas sumas de los
valores disponibles en la Cuenta de Usuario y/o en el Fondo de Reserva a nombre del
Usuario.
El plazo de 24 MSI solo aplica para Banco CitiBanamex, BBVA y American Express.
Plazo Comisión adicional
3 meses 4.19%
6 meses 6.99%
9 meses 9.69%
12 meses 12.51%
18 meses 17.99%
24 meses 22.99%
Para el uso de pagos quincenales con Aplazo mediante QR.
Plazo Comisión
(incluye comisión por el servicio Peiix)
5 quincenas 7.45%
Términos y condiciones del servicio Peiix
11. Prestación del Servicio
1. Peiix usará toda la diligencia razonable para proveer el Servicio las 24 horas del
día, siete días a la semana. No obstante, Peiix no garantiza que el Servicio se encuentre
exento de errores o interrupciones durante este tiempo.
2. Peiix realizará periódicamente mantenimiento y actualizaciones del Servicio, lo que
puede implicar interrupciones, retrasos o errores en el Servicio. Peiix tratará de
comunicar con antelación cualquier mantenimiento previsto, pero no puede
garantizar que dicha notificación se produzca en todos los casos. Además, el Servicio
podrá contener errores o "bugs" que puedan conducir a interrupciones y errores. El Usuario
lo comprende y acepta que Peiix pueda ponerse en contacto con el mismo para ayudarle
con el Servicio y para solicitar información necesaria para identificar y solventar los citados
errores.
3. El acceso del Usuario al Servicio depende de servicios de terceros (tales como
servicios de telefonía móvil). El Usuario acepta que Peiix no tiene ninguna
responsabilidad relacionada con el cumplimiento o los niveles de operación y
continuidad de los mencionados servicios recibidos de terceros.
12. Quejas y obligación de notificación de operaciones no autorizadas
Si el Usuario (i) desea informar errores en el Servicio mediante una queja, o (ii)considera que se
ha cometido un error o que se ha realizado una operación no autorizada relativa a la Cuenta
del Usuario, el Usuario debe notificar a Peiix dicha queja o transacción sin demora después de
que el Usuario lo haya descubierto, o debiera haber descubierto el error o transacción, sin que
pueda exceder de 45 (cuarenta y cinco) días naturales, contactando a Peiix a través de la Página
Web o a través del correo electrónico soporte@peiix.com
13. Responsabilidad de Peiix por el Servicio
1. Peiix es responsable, con sujeción a las limitaciones establecidas en el apartado
siguiente, de garantizar que las operaciones de pago realizadas a través del Servicio se
lleven a cabo correctamente, que las órdenes de pago iniciadas mediante el Servicio
se transfieren correctamente al proveedor de servicios de pago del Tarjetahabiente (el
Adquirente) y que los fondos abonados a los Usuarios sean pagados al Usuario como se
describe con más detalle en el apartado 22, a menos que algo distinto esté contenido en
estos Términos. Si una transacción de pago no se ejecuta correctamente o no se ejecuta
en lo absoluto, Peiix deberá, previa solicitud por parte del Usuario, intentar rastrear la
operación de pago y comunicar al Usuario del resultado.
Términos y condiciones del servicio Peiix
2. Peiix es además responsable por las comisiones o intereses que el Usuario deba pagar
debido a una Transacción de pago no ejecutada correctamente o no ejecutada en
absoluto, en caso de que dicho evento sea imputable a Peiix.
Peiix no será responsable por daños, pérdidas o afectaciones que deriven de actos u
omisiones imputables al Usuario, a terceros, a las Redes de Pago, a los Adquirentes,
a proveedores de servicios de telecomunicaciones o tecnológicos, ni por causas de
fuerza mayor o caso fortuito, conforme a lo previsto en la legislación aplicable.
3. Peiix no será responsable (i) por ninguna otra deficiencia ni error en, o al amparo de, la
prestación del Servicio, (ii) de garantizar que el Servicio esté disponible en todo
momento para la realización de operaciones de pagos, o (iii) por accesos no
autorizados a, o por uso de, la Información de la Cuenta almacenada en los servidores
de Peiix, salvo que las leyes aplicables establezcan lo contrario.
4. En el supuesto de que Peiix tenga conocimiento de que una persona no autorizada
tiene, o ha tenido, acceso a la Información de la Cuenta almacenada en los
servidores de Peiix, informará de esta circunstancia a los Usuarios afectados y, en la
medida de lo posible, proporcionará datos de qué información ha sido revelada.
14. Limitación de responsabilidad
1. Sujeto siempre al apartado 14.2, y sin perjuicio de la normativa de protección del
consumidor que le sea aplicable localmente al Usuario, Peiix no será responsable, bajo
ninguna circunstancia, por daños indirectos, tales como, lucro cesante, pérdida
de datos u otras pérdidas, resultantes del uso o de la falta de uso del Servicio.
2. Sin perjuicio de lo establecido en el apartado 14.1, Peiix será responsable por daño
personal causado por Peiix, daños incurridos por el Usuario debido al dolo o
negligencia grave de Peiix, o cualquier otro asunto con respecto al cual sería ilegal
o contrario a la ley excluir o intentar excluir responsabilidad de Peiix.
3. Sujeto lo anterior, Peiix sólo será responsable por los daños causados únicamente por
la culpa de Peiix y no asume ninguna responsabilidad por ningún acto u omisión de
ningún tercero (“Agente Liquidador”) o participante de redes. Además, Peiix no
deberá ser en ningún caso responsable por ningún daño o pérdida en que incurra el
Usuario como resultado de la obligación de Peiix de cumplir con la ley aplicable, acto u
omisión de cualquier autoridad gubernamental, acto de guerra, accidente, desastre natural,
huelga, bloqueo, u otro evento similar, independientemente de si Peiix es un instigador o
sujeto en dicho evento.
4. Ninguna asesoría o información, verbal o escrita, obtenida por el Usuario de Peiix o a
Términos y condiciones del servicio Peiix
través del servicio creará ninguna garantía no estipulada de manera expresa en los
presentes Términos.
5. Peiix está en facultad de ofrecer su infraestructura para que Terceros ofrezcan
servicios, productos y promociones que proveen a sus Usuarios (los “Servicios de
Terceros”). En el caso de que el Usuario decida utilizar los Servicios de Terceros
bajo su propio riesgo, el Usuario será responsable de revisar y entender los términos y
condiciones relacionados con ellos (“Terceros”) aceptando que Peiix bajo ninguna
circunstancia será responsable del desempeño de dichos servicios, pues este no garantiza
o asume la responsabilidad de ningún producto o servicio que se anuncie u ofrezca por
parte de un Tercero. Los Servicios de Terceros podrán contener vínculos a sitios web como
conveniencia para el Usuario.
6. El Servicio se provee al Usuario sobre una base de “Tal como está” y “Tal como está
disponible”. El uso del Servicio es bajo el propio riesgo del Usuario. Hasta el punto
máximo permitido por la ley aplicable, el Servicio se provee sin garantías de
ningún tipo, ya sean expresas o implícitas. Sin limitar lo anterior, Peiix, sus
procesadores, proveedores, licenciantes (y sus respectivas subsidiarias, filiales y
empleados) no garantizan que el Servicio sea exacto, confiable y correcto, que el Servicio
cumplirá con los requisitos del Usuario, que el Servicio estará disponible en cualquier
momento o ubicación en particular, que el Servicio sea ininterrumpido o seguro, que
cualquier defecto o error se corregirá, o que el Servicio esté libre de virus u otros
componentes dañinos.
7. Peiix se reserva el derecho para procesar la información y rechazar una operación, si
mediante sus procesos de seguridad se determina que una Transacción no puede
llevarse a cabo, cuando este o pudieran considerarse estar apartadas de los
procesos de trazabilidad, verificación, operación y seguridad informática conforme las
condiciones de prevención de fraudes internacionales o domésticas, que enunciativa o no
limitativamente atípicas, de prevención, presunción o constitutivas de fraudes,
debiendo informar inmediatamente al Usuario.
8. Peiix mantendrá sus ingresos en marcha, incluyendo dentro del uso de ingresos, el
mantenimiento del Sistema a fin de que el mismo esté en condiciones aptas para
su operación, y así evitar interrupciones injustificadas de la prestación del servicio.
9. Peiix manejará y mantendrá en resguardo de conformidad con lo establecido en su
Aviso de Privacidad y lo establecido en los presentes Términos. En caso de que el
manejo o resguardo de los Datos Relativos sea comprometido o violados por
terceros, la responsabilidad del mal uso de éstos será de Peiix, siempre y cuando sea
por causas directamente imputables a Peiix y los datos personales se encuentren
en posesión de Peiix este último, en el entendido que el Usuario, su personal y sus
sistemas transmitirán única y exclusivamente los datos a través de los métodos y procesos
de transmisión y seguirán los métodos de seguridad que Peiix establezca y defina, por
Términos y condiciones del servicio Peiix
lo que en caso de que se percaten de alguna vulneración o violación deberá notificarlo
de manera inmediata a Peiix, sin perjuicio de que Peiix deberá manejar y mantener en
resguardo los Datos Relativos y ponerlos a disposición del Usuario en el evento de alguna
reclamación, queja o solicitud expresa y por escrito del Tarjetahabiente, en especial si se
trata del ejercicio de sus derechos de acceso, rectificación, cancelación u oposición
derivado del tratamiento de sus datos personales en términos de la legislación aplicable.
10. Se establece que aquellos Datos Relativos que el Usuario obtenga de los
tarjetahabientes, podrán ser transmitidos a Peiix única y exclusivamente con la finalidad
de dar cumplimiento a la obligación de la prestación de los Servicios, en el entendido
que si éstos son considerados datos personales o sensibles en términos de la Ley
Federal de Protección de Datos Personales en Posesión de los Particulares, el único
responsable de las obligaciones existentes de dicha ley es y será el Usuario, como
enunciativa y no limitativamente son el manejo, tratamiento y custodia de los datos
personales de los Tarjetahabientes que establezcan una relación comercial, contractual o
vinculante en cualquier forma con el Usuario.
11. El Usuario indemnizará a Peiix de cualquier costo, pérdida o responsabilidad que
pudiera resultar de una reclamación contra éste como resultado de la prestación del
Servicio, incluyendo, sin ánimo exhaustivo, cualquier reclamación relativa a defectos
en los productos o
servicios adquiridos con Tarjetas procesadas por el Servicio.
B. OPERACIONES DE PAGOS
15. Tarjetas aceptadas
Como parte del Servicio, las operaciones consistentes en la entrega de recursos al Usuario
derivado de la aceptación que este haya hecho de una Tarjeta para cubrir alguna contraprestación
cierta por la venta de un bien o prestación de un servicio, mediante los cargos correspondientes
en la Cuenta vinculada a dicha Tarjeta y el abono del monto acordado en la Cuenta (“Venta u
Operación de Pago con Tarjeta”), solamente pueden realizarse con las Tarjetas especificadas en
la Página Web. El rango de Tarjetas aceptadas puede cambiar en cualquier momento y sin previo
aviso. El Usuario deberá aceptar todas las tarjetas especificadas en la Página Web para
cualquiera de los de bienes y/o servicios que proporciona.
16. Verificaciones relativas a las operaciones de Pago con Tarjeta
1. En relación con los Pagos con Tarjeta, el Usuario realizará las siguientes verificaciones:
Sí la Tarjeta se tiene a la vista para inspección visual, el Usuario se asegurará de que:
(i) La Tarjeta no ha vencido, (ii) el número de cuenta grabado en la Tarjeta coincide
con el número de cuenta que aparece en el reverso de la Tarjeta, (iii) la Tarjeta
Términos y condiciones del servicio Peiix
cuente con la firma del Tarjetahabiente y que dicha firma coincide con la firma realizada
por Tarjetahabiente en la pantalla del dispositivo utilizado para el Servicio, (iv) La Tarjeta no
tiene ningún indicio de haber sido modificada o de haber sido alterada, (v) la información de
la Tarjeta como género del nombre del Tarjetahabiente es consistente con la observación
del Usuario; y (vi) que cuando se presenta un documento de identificación, que el nombre
grabado en la tarjeta de crédito coincide con el nombre del documento/tarjeta de
identificación. En casos de duda sobre los aspectos anteriores, la Tarjeta no será aceptada
como Medio de Pago. Si el precio de compra excede cierta cantidad establecida por Peiix,
el Tarjetahabiente deberá identificarse con una identificación oficial (i.e. Credencia de
Elector (INE), Pasaporte o licencia de conducir vigentes). Si no pudiera presentarse ningún
documento de identificación o dicho documento ha vencido, la Tarjeta no será aceptada
como Medio de Pago. La firma será comparada por el Usuario con la plasmada por el
Tarjetahabiente en el recibo de pago y con la del documento de identificación. En caso
de duda, la Tarjeta no será aceptada como Medio de Pago. Para aquellas Tarjetas con
autenticación a través de PIN y que los Dispositivos Móviles tengan capacidad de lectura
de PIN, no es necesario que el Usuario solicite identificación oficial al Tarjetahabiente El
incumplimiento por parte del Usuario o la sospecha de incumplimiento por parte de Peiix
a cualquiera de las verificaciones indicadas en la cláusula 16.1 es causa de terminación
de los Términos.
2. El Usuario deberá cumplir con el proceso de cargos realizados a su Cuenta, derivados
de una disputa de un desconocimiento de cargo por motivo de un pago de una Tarjeta
que un tercero con funciones de arbitraje resuelva a favor del Tarjetahabiente o
Emisor (“Contracargos”) y operaciones en disputa.
17. Aprobación de la operación de pago
1. El Usuario deberá asegurarse de que el Tarjetahabiente acepta la operación de pago
y que el importe se deduce de la cuenta del Tarjetahabiente mediante la firma en el
recibo de firma electrónica con su nombre en el correspondiente lugar de la Aplicación.
2. El Usuario deberá tener la autorización expresa del Tarjetahabiente para los cargos
periódicos recurrentes, contando previamente con el respectivo contrato de servicio
debidamente firmado tanto en sus condiciones como en el cargo periódico.
18. Recibos
1. Peiix solamente proporcionará los recibos electrónicamente mediante correo
electrónico o mensaje SMS.
2. El Usuario deberá, si es requerido por un Tarjetahabiente, proporcionar a dicho titular
Términos y condiciones del servicio Peiix
de la Tarjeta un recibo escrito respecto a la transacción de pago realizada, el Usuario
deberá conservar cualquier comprobante generado de la Transacción con el
Tarjetahabiente.
19. Anulación de órdenes de pago
1. La orden de pago no podrá ser anulada después del final del día (a partir de las 23:00
horas, según el apartado 20.5) en que el titular de la tarjeta ha transmitido la orden
de pago o de haber otorgado su consentimiento para ejecutar la operación de pago.
2. El Usuario debe divulgar a los Clientes o Tarjetahabientes cualquier limitación o
restricción en la devolución de la mercancía al momento de la Transacción. Cuando a
solicitud de los Tarjetahabientes, el Usuario requiera efectuar la devolución de alguna
transacción, deberá solicitarla vía dispositivo Peiix dicha solicitud el mismo día en que
se generó la venta antes hasta las 22:59 horas. En caso que la devolución no se
tramite vía Dispositivo, el Usuario deberá solicitar la autorización correspondiente al
Centro de Atención Telefónica Peiix (“CAT Peiix”) y/o mandando la solicitud vía correo
electrónico a soporte@peiix.com y efectuar la devolución de que se trate, precisamente
a la Tarjeta con la cual se celebró la transacción cuya devolución le haya sido solicitada.
3. Peiix cargará en la Cuenta del Usuario, las cantidades que correspondan a la
devolución en un lapso de 24 a 72 hrs. (hábiles) a la fecha en que hubieren sido
recibidas y confirmadas por Peiix. En caso de que el Usuario haya recibido un depósito
por dicha venta y éste no cubra el importe en su saldo operativo para realizar la
devolución, no se podrá devolver dicha transacción hasta que se cubra el monto de la
devolución en la Cuenta del Usuario.
4. Para que el Usuario se encuentre en posibilidad de limitar su aceptación de mercancía
devuelta o de establecer políticas de ajuste de precios, deberá revelar debida y
claramente sus políticas, notificando y acreditando su difusión.
20. Confirmación de operaciones
Cuando se efectúe un pago al Usuario, Peiix actualizará el historial de la Cuenta del Usuario en
la Página Web y en la Aplicación y podrá enviar al Usuario un email confirmando que el pago se
ha realizado e indicando los detalles de la transacción a la terminación de los Términos,
Peiix no tendrá obligación, excepto según se establezca expresamente por ley, de almacenar ni
de proporcionar documentación ni ninguna otra información en relación con ninguna operación
efectuada a través del Servicio.
21. Reembolso a los titulares de la Tarjetas
Términos y condiciones del servicio Peiix
1. El Usuario (i) contará con normas equitativas de devoluciones y cancelaciones de
productos o servicios y con una regulación de pagos con Tarjeta, siempre sujeto a lo
establecido por la Ley Federal de Protección al Consumidor (ii) en el momento de la
compra proporcionará a los clientes las reglas de devoluciones y cancelaciones del
Usuario, (iii) no efectuará reembolsos en efectivo a clientes, y (iv) no aceptará incentivos
en efectivo ni ninguna otra contraprestación por facilitar un reembolso.
2. El Usuario deberá contar con Política de Cancelación y Devolución de pagos en
momento anterior a la celebración de cualquier transacción, en las cuales deberá
constar que es posible la cancelación dentro de un plazo máximo no mayor a 30
(treinta) días naturales previos al cargo de la Tarjeta del Tarjetahabiente, así como
informar las políticas de devolución y cancelación que serán libremente determinadas
por el Usuario (“Política de Cancelaciones y Devoluciones del Usuario”), en el entendido
que cualquier modificación a las mismas deberá ser informada a Peiix con por lo menos
5 días de anticipación a su entrada en vigor. El Usuario deberá otorgar al Tarjetahabiente
como mínimo la siguiente información: i) la fecha de cancelación, ii) número de reporte y iii)
nombre de quien recibió la cancelación.
3. Los reembolsos deberán corresponder a una operación previamente concluida y se
efectuarán utilizando la misma Tarjeta que la usada en la operación de pago. El importe
del reembolso no podrá superar el importe de la correspondiente operación de pago.
4. Si el cliente acepta sustituir un producto y la sustitución implica una diferencia en el
precio de compra, el Usuario deberá reembolsar el importe total de los productos
devueltos y registrar una nueva compra por los nuevos productos.
5. Cualquier monto que el Usuario pretenda devolver (Total o Parcial) posterior al cierre
del día automático centralizado que se realiza entre las 22:30 horas y 23:00 horas (hora
de la Ciudad de México), debe solicitarse a través del CAT Peiix.
22. Protección al consumidor
1. Peiix podrá establecer un máximo de fondos a pagar a la Cuenta bancaria
del Usuario. Dichos límites podrán ser diarios, semanales o mensuales. El monto que
exceda dichos límites será retenido por un lapso no mayor al periodo del límite
excedido. Los límites
de cada Cuenta se informarán en la Aplicación.
2. Al aceptar pagos con Tarjetas internacionales, el Usuario deberá validar la
identificación con fotografía del tarjetahabiente. En caso de que Peiix detecte que no
se realizó, los fondos podrán no ser abonados hasta que se ejecute una investigación
por parte del área de riesgo operativo de Peiix.
Términos y condiciones del servicio Peiix
23. Pagos de Fondos a la Cuenta del Usuario
1. Los fondos acreditados al Usuario para el pago de una Operación de Pago con Tarjeta
no serán abonados a la Cuenta designada por el Usuario hasta que la operación se
haya completado. Una Venta u Operación de Pago con Tarjeta se entenderá
completada a dichos efectos cuando Peiix haya recibido los fondos en la Cuenta
de Usuario. Una vez verificada la Cuenta del banco designada por el Usuario, Peiix
realizará automáticamente, dentro de 1 a 3 días hábiles siguientes a aquél en el que Peiix
ha recibido los fondos en la Cuenta de Usuario, el pago a la Cuenta, salvo que se establezca
lo contrario en los Términos. Dependiendo de, entre otras cosas, la forma en que la
información de la Tarjeta fue obtenida (por ejemplo, mediante el uso de chip o banda
magnética, o tarjeta no presente) los pagos a la Cuenta designada por el Usuario
variarán en función al plazo y límites, lo que le será comunicados al Usuario mediante
publicaciones en la Página Web. A través de la Aplicación, el Usuario será informado
acerca de los pagos realizados a la Cuenta.
2. Peiix se reserva el derecho a retener o retrasar temporalmente la entrega de los fondos
acreditados en la Cuenta de Usuario y/o designar un monto que se deberá retener
en la Cuenta de Usuario, o en el Fondo de Reserva para asegurar el cumplimiento
y/o pago de las obligaciones del Usuario o de los Pasivos del Usuario.
24. Contracargos y operaciones en disputa
1. El importe de cualquier operación puede ser cargado a la Cuenta de Usuario (un
“Contracargo”) si la operación (i) es disputada, (ii) es cancelada por cualquier razón
por la Red, el Adquirente, el Tarjetahabiente o el Emisor de la Tarjeta, (iii) no
fue autorizada o Peiix tuviera motivos para considerar que la operación no haya sido
autorizada, (iv) es presuntamente fraudulenta, ilegal, sospechosa, o incumple en alguna
forma los Términos. El Usuario no volverá a intentar procesar de nuevo cualquier
Operación de Pago con Tarjeta que haya sido afectado por un Contracargo.
2. Para cualquier Operación de Pago con Tarjeta que resulte en un Contracargo,
Peiix tendrá derecho a retener todo importe equivalente a la cantidad estimada del
Contracargo de la Cuenta de Usuario en el Fondo de Reserva. Peiix podrá cargar las
comisiones o sanciones derivadas del Contracargo a la Cuenta de Usuario
(incluyendo la Reserva sin ninguna limitación), la Cuenta o cualquier Medio de
Pago del Usuario registrado con Peiix. Si el Usuario tiene Contracargos pendientes, los
depósitos a su cuenta bancaria pueden ser retenidos o retrasados. De igual
forma, si Peiix considera de forma razonable que una operación cualquiera puede ser sujeto
de Contracargo podrá retener o retrasar la entrega de los fondos de dicha operación
Términos y condiciones del servicio Peiix
hasta que: (i) el Contracargo se evalúa a favor del Tarjetahabiente, en cuyo caso los fondos
serán retenidos, (ii) el tiempo establecido por las autoridades para disputar un Contracargo
ha vencido, o (iii) Peiix determina que el Contracargo de la operación no ocurrirá.
3. Si Peiix no puede recuperar los fondos de un Contracargo, el Usuario deberá cubrir de
manera inmediata el monto total del Contracargo a solicitud de Peiix. El Usuario acepta
pagar los costos y gastos relacionados con el Contracargo incluyendo, pero no
limitado a honorarios y gastos legales, en los que Peiix incurra o incurran terceros
en beneficio de Peiix junto con el total de los Contracargos no pagados por el Usuario.
4. Si Peiix considera que se producen Contracargos relacionados a un Usuario con
demasiada frecuencia, Peiix se reserva el derecho a realizar inspecciones o a
establecer condiciones que rijan la Cuenta y el Servicio, incluido el establecimiento
de nuevas comisiones por el procesamiento de las operaciones, a solicitar importes
de Reserva razonables para cubrir posibles futuros Contracargos, comisiones y sanciones
vinculadas, a limitar el derecho del Usuario a retirar fondos de la Cuenta del Usuario y a
dar por terminado los Términos y finalizar el Servicio.
5. El Usuario acepta que proveerá a Peiix, previa solicitud, su colaboración razonable en
relación con cualquier pago controvertido. Con ese fin, Peiix puede compartir cualquier
información relacionada al Contracargo con el Titular de la Tarjeta, el banco
emisor de la Tarjeta y la institución financiera del Usuario para investigar,
oponerse o resolver el Contracargo. Si el Contracargo es resuelto satisfactoriamente, los
Fondos de la Reserva correspondientes a la operación en disputa serán dispuestos a
través de la Cuenta del Usuario. Peiix se reserva el derecho, previo aviso, a cargar los
costos y gastos de intermediación e investigación de los Contracargos y operaciones en
disputa del Usuario.
6. De conformidad con lo previsto en el artículo 2596 del Código Civil Federal y en el
artículo 57 de la Ley de Instituciones de Crédito, el Usuario autoriza irrevocablemente
a Peiix para compensar las cantidades debidas por el Usuario ya sea mediante
compensación durante los movimientos de las Transacciones o por cargo al saldo del
Usuario, o al fondo de Reserva, o cualquier otro importe que el Usuario mantenga con
Peiix por el monto de todos los Contracargos, incluyendo según resulte aplicable cualquier
fluctuación en el tipo de cambio. El Usuario se obliga a cooperar con Peiix para
cumplir con las regulaciones de las Redes de Pago en relación con los Contracargos
(envío y soporte de información solicitado por Peiix a la afiliación para comprobación de
operaciones a las cámaras reguladoras pertinentes). Él o los Obligados Solidarios son
personalmente responsables con Peiix de todos los Contracargos.
7. El Usuario estará obligado a reembolsar a Peiix el importe de aquellos Medios de Pago
que, habiendo sido liquidados en la Cuenta, no sean reconocidos por el Emisor o por
los Tarjetahabientes, adicional otorga la autorización expresa para que Peiix
Términos y condiciones del servicio Peiix
presente y/o realice las operaciones y en su caso reciba las liquidaciones de Cámaras
de Compensación y/o terceros, incluido American Express.
8. El Usuario autoriza a Peiix con carácter de irrevocable, a cargar sin previo aviso en la
Cuenta las cantidades que se adeuden a Peiix virtud de los presentes Términos
incluyendo en estos conceptos a las comisiones, gastos, impuestos. De igual
forma, el Usuario otorga su consentimiento a fin de que se carguen a la Cuenta
las cantidades acreditadas en forma indebida o, en su caso, improcedentes, en virtud de
no ser reconocidas por el Emisor o por los Tarjetahabientes, en el entendido de que
en estos casos Peiix estará facultado para cargar en la Cuenta, una cantidad adicional por
concepto de comisión por cargo improcedente de Medios de pago, misma cuyo monto se
hará de conocimiento del Usuario en documento por separado.
9. La estipulación a que se refiere el párrafo que antecede, permanecerá vigente y será
aplicable a cualquier otra Cuenta que, en sustitución a la señalada, Peiix llegue
a asignar al Usuario.
10. Peiix se reserva el derecho de liquidar o no en favor del Usuario los Medios de pago,
cuando del análisis de alguna operación en particular, Peiix pueda presumir que se trata
de una operación procesada y transmitida en contravención a lo estipulado en los
presentes Términos, o bien, resulte sospechosa.
11. Peiix podrá cargar comisiones adicionales o sanciones derivadas del Contracargo a la
Cuenta del Usuario (incluyendo la Reserva sin ninguna limitación) más el impuesto
correspondiente, la Cuenta bancaria del Usuario o cualquier Medio de Pago del
Usuario registrado con Peiix, derivado por el contrario cargos improcedentes, bajo la
resolución y dictaminación de las autoridades correspondientes de emitir dicha resolución.
12. Los esquemas de penalización por cargos improcedentes serán de acuerdo al
siguiente criterio y aplicables para los denominados por la autoridad como segundos
Contracargos o Contracargos no atendidos:
1. Si la Transacción en disputa es igual o menor a $2000 se le cargará un importe
de $200 pesos + IVA por concepto de cargo improcedente.
2. Si la Transacción en disputa es mayor a $2000.00 MXN se cobrará el 10 % del total
de la Transacción en disputa + IVA por concepto de cargo improcedente.
3. Si la Transacción en disputa fue procesada como cargo recurrente se cobrarán
$350.00 MXN + IVA por concepto de cargo improcedente.
13. El reembolso o liberación de los importes retenidos a los Usuarios por la Solicitud de
Pagaré y/o Contracargos, serán acreditados al saldo de los Usuarios que mantenga
Peiix una vez que se tenga resolución favorable por parte de las autoridades externas
Términos y condiciones del servicio Peiix
correspondientes a emitir la dictaminación considerando que el ciclo de controversias
puede ser en un periodo de 45 a 180 días naturales para Transacciones domésticas y
hasta 540 días para Transacciones internacionales según lo indique las Redes.
14. La existencia de Contracargos deberá ser notificados por Peiix al Usuario por algún
medio de transmisión segura, informando el detalle preciso de la transacción que está
en disputa. En caso de que el archivo digital del pagaré objeto de la transacción no
cuente con la firma electrónica o exista sospecha o evidencia de que la transacción
es fraudulenta, se realizará la afectación preliminar por el importe en aclaración al Usuario.
Para la atención de Contracargos, el Usuario se compromete a realizar las gestiones
necesarias para enviar la documentación soporte para la atención del Contracargo y
contará con un plazo de máximo de 5 días naturales para enviar dicha documentación
soporte y realizar la representación al Emisor por conducto del Sistema. En caso de no
entregar la documentación soporte no habrá devolución de la afectación preliminar por el
importe en disputa al Usuario.
C. DISPOSICIONES APLICABLES A USUARIOS QUE ACEPTEN PAGOS DE
AMERICAN EXPRESS
El Usuario reconoce que el acuerdo celebrado con la formalización de los presentes Términos,
puede convertirse en una relación de aceptación de Tarjeta directa con American Express, misma
que dará terminación al Contrato. Por lo que acepta expresamente que, en caso de aplicar dicho
supuesto, (i) estará obligado por el Contrato de Aceptación de Tarjeta vigente de American
Express; y (ii) American Express establecerá el precio y otras tarifas pagaderas por la aceptación
de la Tarjeta, por lo que se obliga a cumplir con los requisitos de seguridad de datos de American
Express y PCI DSS, adicional a los requisitos de Peiix.
El Usuario no cederá a ningún tercero cualquier pago que le sea debido bajo el presente,
y toda cantidad recibida es por la venta de buena fe de bienes y servicios, mismas que se
encuentran libres de gravámenes, demandas y cargos distintos de impuestos sobre ventas
ordinarios; en el entendido, sin embargo, que solo podrá vender y ceder las cuentas por cobrar
de operación futura a Peiix sin el consentimiento de American Express.
Como parte de la presente relación Peiix confiere a American Express derechos de tercero
beneficiario, con relación al presente documento, por lo que le proporcionara a American Express
la capacidad plena de hacer valer los términos establecidos frente al Usuario por lo cual, este
último está de acuerdo con ello ya que acepta y reconoce expresamente que Peiix podrá
divulgar los datos de su operación, y otra información acerca del usuario a American Express,
para que este último utilice dicha información para el cumplimiento de sus responsabilidades
en relación con la aceptación de pagos con tarjetas en la Red American Express, por lo que
es obligación del Usuario cumplir cabalmente con los requisitos y características de información
que Peiix comunique.
El presente apartado podrá ser inaplicable, para el caso de que el Usuario determine y
exprese su deseo para dar de baja de aceptar las Tarjetas American Express, lo cual podrá
solicitar en cualquier momento sin afectar directa o indirectamente sus derechos de aceptar otros
Términos y condiciones del servicio Peiix
Medios de Disposición, adicionalmente el Usuario acepta que en caso de haber notificado la baja
deberá retirar de todo sitio lo referente a Marcas de American Express de forma inmediata.
El Usuario acepta que las políticas de reembolso establecidas para las compras con la
Tarjeta American Express deben ser por lo menos igual de favorables que su política de
reembolso para compras con Medios de Disposición distintos y la política de reembolso se
divulgara a los Tarjetahabientes al momento de la compra y en cumplimiento con la legislación
aplicable.
D. ESTIPULACIONES VARIAS
25. Privacidad y almacenamiento de datos
1. El Usuario protegerá, y salvo que sea requerido por autoridad competente, no revelará,
registrará o de otra forma procesará información de Tarjetas u otra información relativa
al Tarjetahabiente que el Usuario pueda recibir durante las operaciones de pago,
salvo que se realice de conformidad con los Términos. Si el Usuario conociese o
sospechase de un comunicación no autorizada de dicha información, el Usuario lo
informará inmediatamente a Peiix y proporcionará a Peiix dicha documentación y
apoyo que sea requerida por Peiix y actuará siguiendo las instrucciones razonables de
éste. El Usuario también gestionará la información de Tarjetas de conformidad con los
estándares y directrices emitidas por el estándar PCI por sus siglas en inglés en
todo momento y que se encuentran en www.pcisecuritystandards.org
(http://www.pcisecuritystandards.org/).
2. La información referida en el apartado 24.1 anterior, durante la duración de los
Términos y en lo sucesivo, se utilizará por el Usuario exclusivamente para la utilización
del Servicio y de conformidad con lo previsto bajo los Términos y en la normativa
aplicable, incluyendo, aunque no limitado, a la normativa de protección de datos.
3. El Usuario entiende y acepta que Peiix podrá revelar cualquier información
proporcionada a Peiix o a su banco adquirente a las Redes con el objeto de
determinar la identidad de un individuo, incluyendo Tarjetahabientes, de conformidad
con lo previsto con las reglas emitidas por las Redes y tal y como lo permita la normativa
aplicable.
4. Al usar el Servicio, el Usuario puede recibir información acerca de sus clientes u
otros terceros. El Usuario deberá conservar dicha información como confidencial y
usarla únicamente en relación con el Servicio. El Usuario no puede divulgar ni
distribuir parcial o totalmente dicha información de terceros, ni usar la información con
propósitos de mercadotecnia a menos que reciba el consentimiento expreso del tercero.
Términos y condiciones del servicio Peiix
26. Comentarios sobre el Servicio
El Usuario podrá presentar comentarios o ideas sobre el Servicio mediante la remisión de un
correo electrónico a la dirección contacto@Peiix.com, a través de la Aplicación o la
Página Web. Peiix no estará obligado a aplicar ninguno de dichos comentarios ni ideas. El
Usuario no tendrá derecho a compensación por las ideas y comentarios presentados, pero Peiix
podrá utilizarlos libremente y asimilar todos los derechos pertenecientes a los mismos.
27. Vigencia y resolución
1. El Contrato tendrá una vigencia de 12 (doce) meses contados a partir del día de su firma
o aceptación electrónica, pudiendo renovarse de forma automática y sucesiva por
periodos iguales de 12 meses cada uno; sin perjuicio de lo anterior, las Partes
podrán dar por terminado el Contrato en cualquier momento, mediante el envío de una
notificación por escrito a la otra Parte con al menos 30 (treinta) días de anticipación a la
fecha en que se pretenda terminar con los Servicios. No obstante lo anterior, cualquier
obligación de pago que esté pendiente de realizarse entre las Partes conforme a lo
dispuesto en los Términos, así como la atención de cualquier Pasivo del Usuario,
prevalecerá vigente hasta en tanto no sean atendidas y debidamente liquidadas, y conste
el acuerdo respectivo expresamente y por escrito entre la parte acreedora y la deudora.
Peiix realizará una retención de saldos por 180 (ciento ochenta) días o 540 (quinientos
cuarenta) días, según aplique, para contrarrestar las eventuales implicaciones de las
Transacciones que pudieren resultar contracargadas luego de la terminación del
Contrato. El Usuario reconoce que Peiix no estará obligado a reembolsarle ninguna
Comisión pagada por cualquier Transacción efectuada utilizando el Servicio antes de la
solicitud de terminación.
2. Si la relación de Peiix con su Adquirente venciera o se terminara por cualquier motivo,
o si Peiix fuera cancelado del registro de las Redes, estos Términos se darán por
terminados de forma inmediata por imposibilidad de ejecución de los Servicios.
3. Peiix tendrá derecho a bloquear la Cuenta de Usuario, a rechazar el acceso
del Usuario al Servicio y/o a dar por terminado el Contrato de forma
inmediata, si (i) Peiix tiene constancia de, o motivos razonables para creer, que el
Usuario utiliza o va a utilizar el Servicio en contravención de los Términos, de cualquier
ley o reglamento aplicable o de las normas de las Redes o del Adquirente de Peiix; (ii) se
hubiera revelado información relativa a protocolos técnicos o administrativos de seguridad
de datos, de forma que existan motivos razonables para considerar que la Cuenta de
Usuario va a ser utilizada abusivamente; (iii) si existen otros motivos razonables para
considerar que la Cuenta de Usuario ha sido o va a ser utilizada de manera abusiva o con
la finalidad de desarrollar o encubrir actividades catalogables como de fraude; (iv) si una
Términos y condiciones del servicio Peiix
garantía necesaria para asegurar el cumplimiento de los Pasivos del Usuario no es
otorgada a requerimiento de Peiix; (v) si el volumen de negocio anual de la Cuenta de
Usuario excede la cantidad establecida bajo estos Términos y el Usuario no se encuentra
interesado en celebrar un Contrato de Adquirente; o (vi) bajo el supuesto establecido en
el apartado 2.7.
Las Partes aceptan que está prohibido utilizar el Sistema para realizar cualquier Actividad
No Autorizada. Cualquier incumplimiento a lo antes establecido será considerado como una
causal de terminación del Contrato y facultará a Peiix a dar por terminada la
relación con el Usuario sin necesidad de requerimiento judicial o extrajudicial y sin
responsabilidad para Peiix. En este caso, Peiix se reserva el derecho de impedir el ingreso
o uso del Sistema al Usuario, así como a eliminar la información que le haya sido
suministrada.
4. Adicionalmente, el Contrato terminará por cualquiera de las siguientes causas:
1. Mutuo acuerdo de las partes;
2. Incumplimiento total o parcial de alguna de las obligaciones pactadas en el Contrato
o establecidas en los Términos, que afecte el desarrollo de aquel, que no sea
subsanado dentro de los diez (10) días hábiles siguientes a la notificación de la
parte cumplida a la parte incumplida, o que no pueda ser subsanado;
3. Por el Usuario, si no está de acuerdo con las nuevas tarifas ajustadas
unilateralmente por Peiix, en caso de producirse una modificación en las condiciones
comerciales con los Participantes;
4. Peiix también podrá terminar el Contrato unilateralmente y de manera inmediata, en
caso de que (i) así sea requerido por algún Participante. Peiix y el Usuario tratarán
de resolver esta solicitud de buena fe. En todo caso, Peiix no asumirá
responsabilidad alguna; y (ii) con base en información recibida concluyente respecto
de la existencia de riesgos reputacionales, legales, de cumplimiento, o de otra índole
que le impidan continuar prestando Servicios al Usuario.
5. Con la terminación del Contrato, el Usuario acepta que (i) ya no tendrá derecho a utilizar
el Servicio y vencerá la licencia otorgada; y (ii) la prerrogativa de ejercicio
facultativo de Peiix, según su criterio fundado en los antecedentes y registros
existentes para la prestación de los Servicios al Usuario, a exigir del Usuario,
como requisito para la terminación del Contrato: (i) descontar de los montos de Ventas
futuras o de la Cuenta de Usuario y/o delas Cuentas de Usuario de las sociedades afiliadas
del Usuario, el valor necesario para garantizar el pago de Contracargos, multas,
penalidades, devoluciones, ajustes u otros conceptos; o, si los recursos disponibles de las
ventas futuras o en las precitadas Cuentas de Usuario no fueren suficientes, exigir del
Usuario la constitución de una garantía admisible para el equipo de riesgos de Peiix (tales
como depósito de recursos pignorados en cuenta, garantía o aval bancario) por el valor
necesario para garantizar el pago de los Pasivos del Usuario.
Términos y condiciones del servicio Peiix
El monto total descontado o la garantía constituida, será devuelto al Usuario transcurrido
el plazo necesario para cubrir el término de admisibilidad de Contracargos según la ley
aplicable o según se trate de compras efectuadas sobre bienes y/o servicios que no serán
disfrutados en el momento de la compra, sino en uno muy posterior, tales como planes
vacacionales, servicios de hospedaje o tiquetes aéreos; y una vez se verifique que no
existen Contracargos, reversiones, devoluciones, ajustes, cuotas, recargos, cobros por
las Redes, multas, penalidades o, en general, Pasivos del Usuario pendientes de ser
atendidos.
6. Las estipulaciones de los apartados 12, 13 y 23 anteriores seguirán siendo de aplicación
tras el vencimiento o terminación de los Términos.
28. Tratamiento de datos personales.
Peiix trata datos personales relativos al Usuario y a su utilización del Servicio (los "Datos
Personales") con base a lo dispuesto en el Aviso de Privacidad que ha sido puesto a disposición
al Usuario, por lo que este último declara que conoce el alcance de la totalidad de los
términos establecidos en el mismo, reconociendo el Usuario su total aceptación y el
reconocimiento de que en cualquier momento puede ser consultar dicho Aviso de Privacidad
en la Página Web, así como garantizar la calidad de datos e información que transmita para
que se procese oportuna, exacta y completamente en cumplimiento con lo dispuesto por Peiix,
para el caso de que existan requerimientos específicos o especificaciones técnicas dadas por los
Titulares de Marcas, Cámaras de Compensación o cualquier Participante en Redes que participe
en la prestación de los servicios, el Usuario deberá cumplir con las mismas de manera oportuna.
29. Notificaciones e información
1. Las notificaciones escritas de Peiix al Usuario se enviarán en español y serán remitidas
por correo electrónico, mensajería privada o correo certificado, siempre que: (i) sean
dirigidas al domicilio de la Parte correspondiente y (ii) conste fehacientemente
la entrega de la notificación. (iii) la ley no requiera de otra formalidad para el
caso en específico. Toda notificación remitida al Usuario de esta forma se considerará
recibida por el Usuario a más tardar al día hábil siguiente.
2. Aquella información que Peiix deba proporcionar al Usuario de conformidad con Ley
Federal de Protección de Datos Personales en Posesión de Particulares está
disponible en todo momento a través de la Página Web.
30. Cesión
El Usuario no podrá ceder o transmitir ningún derecho derivado de los presentes Términos
ni obligación en relación con el Servicio ni con la Cuenta del Usuario a ningún tercero sin el previo
Términos y condiciones del servicio Peiix
consentimiento por escrito de Peiix, conviniendo las partes que cualquier cesión en violación será
nula. Peiix tiene derecho a ceder total o parcialmente a un tercero sus derechos al amparo de los
Términos sin el consentimiento del Usuario.
31. Adiciones y modificaciones
Peiix, a su discreción, se reserva el derecho de: (i) modificar estos Términos y (ii) limitar o eliminar
la disponibilidad del Sistema, en cualquier momento, sin previo aviso a entera discreción de Peiix.
Si se llegara a determinar que algún término, condición o disposición de estos Términos es ilegal,
inválida, nula o por cualquier razón, inaplicable, la validez y aplicación de las demás disposiciones
no serán de ninguna manera afectadas o deterioradas. Este instrumento constituye un acuerdo
completo entre el Usuario y Peiix.
Sin perjuicio de lo anterior, Peiix podrá modificar estos Términos cuando así lo dispongan o
requieran las Autoridades, el cumplimiento y/o atención de un requerimiento de las Redes,
o por motivos de seguridad; a este efecto, Peiix dará aviso al Usuario de las modificaciones
realizadas; en caso de no estar de acuerdo con esta modificación, el Usuario podrá dar por
terminado el Contrato, sin responsabilidad para Peiix o para el Usuario.
32. Controversias y conflictos
1. Las PARTES expresan su firme convicción que, actúan de buena fe y en caso de
presentarse diferencias en la interpretación y/o cumplimiento en los Términos y sus
anexos, por lo que las partes podrán tener un primer acercamiento buscando dar
solución mediante un proceso de negociación antes de aplicar cualquier pena, interés
o declarar la rescisión; tratarán razonablemente de resolverlas entre ellas en forma
amistosa, en un plazo de al menos 15 (quince) días naturales y seguirán un proceso de
consulta mutua a efecto de evitar controversias y en caso de que las partes no puedan
solucionar mediante negociación y comunicación amigable las controversias suscitadas, las
mismas serán resueltas por los juzgados y tribunales Mexicanos, para lo cual Peiix
informa su procedimiento de resolución.
2. Los Términos se interpretará de conformidad con las Leyes Mexicanas y toda
controversia relativa a los Términos las partes se comprometen a dar su mejor esfuerzo
para la solución mediante un proceso autocompositivo y en caso de que las partes
no puedan solucionar mediante negociación amigable las controversias suscitadas, las
mismas serán resueltas por los juzgados y tribunales mexicanos.
3. En caso de cualquier discrepancia entre estos Términos y las reglas emitidas por las
Redes, dichas reglas prevalecerán en los términos permitidos por la normativa
imperativa aplicable.
4. Serán causas de rescisión de los Términos, mediante notificación escrita y sin
Términos y condiciones del servicio Peiix
necesidad de declaración judicial, sin responsabilidad de la Parte no culpable y
además de las ya previstas en otras partes del mismo, las siguientes:
1. Si el Usuario hace mal uso del Sistema que le será otorgado por Peiix para el
cumplimiento de los Términos de conformidad con la Lista de Buenas y Malas
Prácticas en Transacciones con Tarjeta, actividades fraudulentas o contrarias a la
legislación aplicable.
2. Si cualquiera de las Partes incumple cualquiera de las demás obligaciones a su cargo
derivadas de estos Términos.
33. Páginas web de terceros
La Web podrá contener links o redirecciones a otras páginas web que no son
operadas por Peiix. Peiix no controla ni asume ninguna responsabilidad por el contenido de
dichas páginas webs.
El Usuario es plenamente responsable de la utilización y acceso a dichas páginas web por lo
que se le aconseja leer cuidadosamente cualesquiera términos y condiciones y políticas
relativas a datos personales y confidencialidad que puedan ser aplicables.
34. Auditoría
El Usuario acepta que Peiix tendrá derecho a llevar a cabo una auditoria del
negocio del Usuario, ya sea por sí mismo o a través de tercero designado por Peiix (incluyendo
análisis o estudios acerca de la ubicación y establecimiento del negocio), en la medida que Peiix
considere necesario para garantizar el cumplimento de las leyes aplicables, las reglas
del Adquirente de Peiix, las Redes y/o los Términos.
35. Servicio de pago a través del Sistema Peiix (Agente Liquidador)
Peiix podrá poner a disposición de un Agente liquidador el servicio de aceptación de pago con
Tarjeta, y consistirá en lo siguiente:
1. Peiix liquidará al Agente liquidador para que este a su vez liquide al Usuario el importe
neto de los pagos efectuados con Tarjetas, en el entendido que ha recibido la instrucción
expresa y cuenta con autorización por parte de los Usuarios para ser liquidados los
recursos a estos por conducto del Agente Liquidador, siendo responsabilidad de este
último, el liquidar en la forma y términos acordados con los Usuarios con base en sus
propias políticas de liquidación, obligándose a sacar en paz y a salvo a Peiix ante cualquier
reclamación de los Usuarios y, en consecuencia, asumir cualquier afectación financiera,
gasto, penalización, pérdida o menoscabo que se suscite como consecuencia de o
resultado de la falta de liquidación a los Usuarios por parte de agente liquidador.
Términos y condiciones del servicio Peiix
2. La liquidación de las ventas realizadas por el Usuario será realizada:
1. En una sola exhibición diaria, de acuerdo con el calendario de días hábiles de la Bolsa
Mexicana de Valores, antes del horario del cierre del Sistema de Pagos Electrónicos
Interbancarios SPEI, a la cuenta CLABE proporcionada por el Usuario en el
Contrato; como evidencia, se entregará una copia del estado de Cuenta para validar
los datos proporcionados.
2. En caso de contingencia, ya sea por el Banco Adquirente, las cámaras de
compensación, American Express o con el sistema SPEI, Peiix notificará al Usuario
vía correo electrónico, e informará el tiempo posible de solución; de no alcanzar el
horario máximo de cierre, los recursos serán liquidados al siguiente día hábil
acumulando la liquidación del día anterior.
3. Liquidación Complementaria: solicitudes de Pagaré y Contracargos y otros ajustes
(previa notificación al Usuario).
36. Fondos de Reserva.
1. Durante la vigencia del Contrato, el Usuario faculta a Peiix a constituir un Fondo de
Reserva suficiente para garantizar a Peiix el cumplimiento de todas y cada una de las
obligaciones a cargo del Usuario conforme a lo previsto en los presentes
Términos. Peiix se encuentra autorizado a constituir el Fondo de Reserva, con cargo a
las cantidades que el Peiix deba cubrir al Usuario y en el momento en que ocurra cualquiera
de los Eventos de Reserva definidos en la presente cláusula. Peiix debe dar a conocer
al Usuario la cantidad afectada al Fondo de Reserva, así como cualquier modificación o
incremento a la misma.
2. El monto del Fondo de Reserva será determinado, incrementado, disminuido o
eliminado en cualquier momento, con base en criterios objetivos por parte de Peiix, o
en conformidad con solicitudes recibidas del Adquirente o las Redes para cubrir
Contracargos anticipados, devoluciones, operaciones en disputa o eventuales
detrimentos asociados a la concreción de situaciones de riesgo operativo registradas en
el historial de Transacciones del Usuario.
3. Si los recursos disponibles en el Fondos de Reserva del Usuario no son suficientes
para cubrir los Pasivos del Usuario o el monto designado por los Participantes, Peiix
podrá obtener los fondos faltantes de cualquier fuente de fondeo relacionada
con la Cuenta Peiix y/o con la Cuenta del Usuario, incluyendo pero no limitando
a (i) depósitos del Usuario a su Cuenta, (ii) recursos en deuda al Usuario bajo estos
Términos, (iii) recursos disponibles en la Cuenta (iv) otra Cuenta de Usuario registrada
en el sistema con el mismo RFC (Registro Federal de Contribuyentes) del Usuario,
razón social, misma cuenta de depósito o cualquier otro medio de disposición registrado
27/05/25, 8:32 p.m.
Términos y condiciones del servicio Peiix
con Peiix.
4. El Usuario otorga a Peiix un derecho de garantía y retención sobre cualquier y todos
los recursos disponibles en el Fondo de Reserva y en la Cuenta de Usuario,
y autoriza a Peiix a realizar cualquier retiro, cargo o débito, tanto de la Cuenta de
Usuario, como del Fondo de Reserva, sin necesidad de previo aviso, para cobrar
las cantidades que el Usuario adeude a Peiix en virtud de los Términos, incluyendo sin
limitaciones de ningún tipo, reversiones de depósitos o transferencias a la Cuenta
Peiix.
El Usuario deberá entregar cualquier documentación o información adicional
requerida por Peiix para perfeccionar la garantía sobre los recursos disponibles en el
Fondo de Reserva. Esta garantía estará vigente mientras se mantengan recursos en
el Fondo de Reserva del Usuario.
5. Eventos de Reserva. Serán considerados como Eventos de Reserva los supuestos que,
de forma enunciativa pero no limitativa, se mencionan a continuación:
1. La verificación de Transacciones fraudulentas realizadas por el Usuario o
registradas bajo su Cuenta de Usuario en uso de los Servicios
2. Contracargos que durante un mes sean iguales o superiores entre un 30% hasta
70% y 100% del valor de las Transacciones realizadas en los comercios (dicha retención
se aplicará de acuerdo con la dictaminación del análisis realizado por parte del
departamento de riesgo de Peiix).
3. Por transaccionalidad alta del Usuario (prevención de aclaraciones futuras, porcentaje
del 10% al 20%). Dicha retención se aplicará de acuerdo con la dictaminación del
análisis realizado por parte del departamento de riesgo de Peiix.
4. La falta en el cumplimiento por parte del Usuario a cualquiera de sus obligaciones
conforme a lo previsto en los presentes Términos.
5. La imposición de multas por parte de las Redes.
6. Cualquier situación, hecho o evento material adverso que afecte la situación
financiera del Usuario.
7. Cuando las garantías resulten insuficientes para garantizar el cumplimiento de las
obligaciones del Usuario establecidas en los Términos.
6. Uso del Fondo de Reserva. Peiix podrá disponer del Fondo de Reserva, sin que medie
autorización previa alguna, diferente a la aceptación de estos Términos por
parte del Usuario, bajo las siguientes reglas:
1. Mediante cargos para pagar y liquidar cualquier Pasivo del Usuario y, en
general, cualquier cantidad que el Usuario deba pagar a Peiix conforme
a lo previsto en los presentes Términos.
2. Mediante la compensación de las cantidades que de cualquier otra
Términos y condiciones del servicio Peiix
forma Peiix esté obligado a pagar al Usuario.
3. Para realizar pagos en favor de un Participantes del Sistema,
correspondientes a
obligaciones existentes y actualmente exigibles en cabeza del Usuario,
derivadas, de reclamaciones u obligaciones asumidas por el Usuario en
asocio al uso de los Servicios.
7. Terminación del Contrato y Restitución del Fondo de Reserva. Peiix depositará en la
Cuenta CLABE del Usuario el importe que se mantenga en el Fondo de Reserva
siempre y cuando:
1. El Evento de Reserva haya desaparecido, previo acreditamiento de tal
circunstancia por parte del Usuario y mediando conformidad por escrito de
Peiix.
2. El Usuario haya cumplido en su totalidad con cualquier obligación a su cargo
derivada de los presentes Términos, incluyendo la atención y/o pago de todos
los Contracargos, devoluciones, ajustes, cuotas, tasas y/o penalizaciones
de las Redes de Pago y, en general, todo Pasivo del Usuario a cargo del
Usuario haya sido confirmado como atendido por parte de Peiix.
3. Peiix liberará el remanente del Fondo de Reserva, una vez que hayan sido
deducidas todas las obligaciones vencidas en su favor derivadas de los
presentes Términos, mediante depósito en la Cuenta CLABE.
4. El evento de reserva haya desaparecido por el vencimiento de su aplicación,
y de acuerdo a los tiempos establecidos por la Red y los emisores.
37. No relación laboral
Las Partes en este acto reconocen que no existirá relación laboral de ninguna clase entre ellas o
en relación con los empleados de cada una de las Partes, sus agentes o el personal contratado
para lograr los objetivos de estos Términos; por lo tanto, nunca existirá ninguna relación
contractual o laboral entre cualquiera de las Partes y los empleados de la otra. Como
consecuencia de lo anterior, y toda vez que las Partes cuentan con elementos propios para
ser consideradas como patrones en términos del artículo 13 de la Ley Federal del Trabajo, cada
una de las Partes se obliga a asumir sus obligaciones de cualquier naturaleza frente a sus propios
empleados. Los empleados, agentes y en general cualquier elemento de la fuerza de trabajo del
Usuario continuarán con tal carácter y no tendrán el estatus de empleados de Peiix o cualquier
derecho a las prestaciones que Peiix brinde a sus empleados, ni viceversa.
Las Partes se obligan a sacar en paz y a salvo a la otra Parte de cualquier demanda o reclamación
individual o colectiva que un sindicato pudiera iniciar como consecuencia de la existencia de
trabajadores de cualquiera de las Partes.
38. Confidencialidad
Términos y condiciones del servicio Peiix
Las Partes reconocen desde este momento que toda la información contenida en cualquier
documento que una le entregue a la otra o haga de su conocimiento con respecto a los Servicios,
el Sistema, listas de clientes, datos de los Tarjetahabientes o cualquier otro aspecto relacionado
directa o indirectamente con estos Términos constituye información confidencial y
consecuentemente secretos comerciales, en los términos de las leyes y reglamentos aplicables.
En este sentido, las Partes se obligan a guardar la más estricta confidencialidad respecto de dicha
información y no podrán autorizar su uso a ninguna persona, ni copiarla o reproducirla en forma
alguna. Esta obligación será extensiva a cualquier empleado, directivo, accionista, consejero,
asesor o cualquier otra persona que directa o indirectamente se encuentre relacionada con las
Partes o con alguna de sus filiales o subsidiarias y cada Parte será responsable de las
divulgaciones que se realicen sin el consentimiento de la otra Parte y de los daños y perjuicios
que se causen.
Una vez terminado los Términos, las Partes deberán devolverse toda la información relacionada
con los Servicios, el Sistema, listas de clientes, datos de los Tarjetahabientes o cualquier otro
aspecto de estos Términos que hubiesen recibido de la otra Parte. La obligación de
confidencialidad permanecerá vigente durante la vigencia de los Términos y durante 3 (tres) años
contados a partir de la fecha en que los Términos deje de tener efectos.
39. Encabezados
Las Partes convienen en que los encabezados que aparecen al inicio de cada una de las cláusulas
que conforman estos Términos y, se han insertado única y exclusivamente para facilitar su lectura
y manejo, motivo por el cual, no se considerará en ningún caso que definan o limiten las
obligaciones.
40. Publicidad
En virtud de los presentes Términos, el Usuario autoriza a Peiix para que éste pueda identificarlo
como su cliente por cualquier medio y para que haga uso de las marcas comerciales, nombres
de dominio, denominación o razón social del Usuario, exclusivamente en conexión con los
presentes Términos y el Servicio prestado. Adicionalmente, el Usuario autoriza el uso de la
información de su empresa y logo en cualquier caso de promoción a desarrollarse en conjunto
con Peiix, lo cual se notificará de manera previa del equipo de Comunicaciones de la empresa.
Estos Términos se aplicarán a partir de 15 de enero de 2026 hasta nuevo aviso.

Reconozco que las comisiones aplicables a las transacciones serán del 3.50% para cobros con tarjetas de crédito, débito, American Express e Internacionales, y para tarjetas de vales (cuando aplique) será del 6.00%, en todos los casos se deberá sumar el IVA correspondiente`;

export default function TermsModal({
    isOpen,
    onClose,
    onAccept,
    accepted,
    onToggleAccept,
    loading
}) {
    if (!isOpen) return null;

    return (
        <div className="terms-modal-overlay">
            <div className="terms-modal-content">
                <div className="terms-modal-header">
                    <h3>Términos y Condiciones</h3>
                    <button
                        type="button"
                        className="terms-modal-close-btn"
                        onClick={onClose}
                        aria-label="Cerrar modal"
                    >
                        &times;
                    </button>
                </div>

                <div className="terms-modal-body">
                    <div className="terms-text-box">
                        {TERMS_AND_CONDITIONS_TEXT}
                    </div>
                </div>

                <div className="terms-modal-footer">
                    <div className="terms-checkbox-container">
                        <input
                            type="checkbox"
                            id="acceptTermsCheckbox"
                            checked={accepted}
                            onChange={(e) => onToggleAccept(e.target.checked)}
                        />
                        <label htmlFor="acceptTermsCheckbox">
                            He leído y acepto los Términos y Condiciones y el Aviso de Privacidad.
                        </label>
                    </div>

                    <div className="terms-modal-actions">
                        <button
                            type="button"
                            className="terms-btn-cancel"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className="terms-btn-accept"
                            disabled={!accepted || loading}
                            onClick={onAccept}
                        >
                            {loading ? <Spin /> : 'Aceptar y Continuar'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
